import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  VStack,
  Text,
  HStack,
  Center,
  FlatList,
  Pressable,
  Menu,
  Button,
  Spinner,
  Divider,
  Tooltip,
  Modal,
  Input,
  Image,
} from "native-base";
import {
  AddIcon,
  Profile,
  MicIcon,
  EditIcon,
  VideoIcon,
  AddPhotoIcon,
  GroupChatIcon,
  MoreHorizontalIcon,
} from "../../assets/icons/icon-assets";
import { Loc } from "../../App/Loc";
import helping from "../../assets/images/helping.png";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import { useDropzone } from "react-dropzone";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { useParams, useNavigate } from "react-router-dom";
import CustomToast from "../../Hooks/useCustomToast";
import { useDispatch, useSelector, RootStateOrAny } from "react-redux";
import AVBody from "../../components/common/AVBody";
import Messages from "../chat/screens/MainScreen";
import AVFeedsProfile from "../Feeds/AVFeedsProfile";
import Createalbumpopup from "../Home/Createalbumpopup";
import { setConvo } from "../../Redux/Actions/convoActions";
import _ from "lodash";
import * as AV from "../../AVCore/AVCore";
import { Linking } from "react-native";
import { Media } from "../../AVCore/Media";
import useConvoChat from "../../Hooks/useConvoChat";
import {
  setEntitydata as setEntitydataAction,
  setUser,
} from "../../Redux/Actions/userActions";
import useAlerts from "../../Hooks/useAlerts";
import AVCancel from "../../components/common/AVCancel";
import AVInputtext from "../../components/AVInputtext";
import { AVBase } from "../../AVCore/AVBase";
import { useLocation } from "react-router-dom";
import AVImageSlider from "../../components/common/AVImageSlider";
import settings from "../../Platform/settings.json";
import VoiceMessage from "../../components/common/VoiceMessage";
import inform from "../../assets/images/inform.png";
import { useWindowDimension } from "../../Utility/WindowDimensions";
import AVPersonaModal from "../../components/common/AVPersonModal";
import AVConfirmationModal from "../../components/common/AVConfirmationModal";
import StaffsCard from "../../components/teams/StaffsCard";

const AVHuddles = (props: any) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentUser = useSelector(
    (state: RootStateOrAny) => state?.user?.user[0],
  );
  const userconvo = useSelector(
    (state: RootStateOrAny) => state.convo.convo[0],
  );
  const isOnline = useSelector(
    (state: RootStateOrAny) => state.user.isOnline
  )
  const userID = useParams()?.userId;
  const location: any = useLocation();

  const [isHuddleData, setIshuddleData] = useState(() => {
    if (location?.state?.HuddleData?.id) {
      return location.state.HuddleData;
    }

    // get all channels from orgs
    const channels =
      currentUser?.orgs?.filter((org) => org.type === "Channel") ?? [];

    // Create a map of conversation lastUpdated times for quick lookup
    const convoUpdateMap = new Map<string, string>(
      userconvo?.map((convo) => [convo?.id, convo?.lastUpdated]) ?? [],
    );

    // Sort channels based on their corresponding conversation's lastUpdated
    const sortedChannels = channels.sort((a, b) => {
      const lastUpdatedA: string =
        convoUpdateMap.get(a.data) ?? new Date().toISOString();
      const lastUpdatedB: string =
        convoUpdateMap.get(b.data) ?? new Date().toISOString();

      // Convert to Date objects for comparison
      const dateA = new Date(lastUpdatedA);
      const dateB = new Date(lastUpdatedB);

      // Sort in descending order (most recent first)
      return dateB.getTime() - dateA.getTime();
    });

    return sortedChannels[0];
  });

  const [activeTab, setActiveTab] = useState<string>(
    location?.state?.type
      ? location?.state?.type
      : Loc.currentLang.activity.headers.chat,
  );
  const [isNewChat, setIsNewChat] = useState(false);

  // Add required states for Messages component
  const [showEmoji, setShowEmoji] = useState(false);

  const [entityData, setEntityData] = useState<AV.IAVEntity>();
  const [albumlist, setalbumlist] = useState([]);
  const [filesList, setfilesList] = useState<AV.ILink[] | null>([]);
  const [allImages, setShowAllImage] = useState([]);
  const [itemHeights, setItemHeights] = useState([]);
  const [singleImage, setSingleImage] = useState();
  const [isHeader, setHeader] = useState(false);
  const [setConvoImage] = useState();
  const [showPreview, setShowPreview] = useState(false);
  const [previewitem, setpreviewitem] = useState();
  const [commentValue, setCommentValue] = useState<string>("");
  const [IsOpenConvo, setIsOpenConvo] = useState(false);
  const [showConvoListModal, setShowConvoListModal] = useState(false);
  const [convoData, setIsConvoData] = useState(false);
  const [createType, setCreateType] = useState<string>("");
  const [showCreateNewPage, setShowCreateNewPage] = useState<boolean>(false);
  const [showEdit, setIsShowEdit] = useState(false);
  const [isRotate, setIsRotate] = useState(false);
  const [isAdminView, setIsAdminView] = useState(false);
  const [isMember, setIsMember] = useState(false);
  const [isStaff, setIsStaff] = useState(false);
  const [selectType, setSelectType] = useState<string>();
  const [itemSelect, setItemSelect] = useState<any>("");
  const [isConfirmDelete, setisConfirmDelete] = useState(false);
  const [confirmationText, setConfirmationText] = useState("");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement | null>(null);
  const menuIconRef = useRef<HTMLDivElement | null>(null);

  // Add a ref to track the current chat ID
  const currentConvoIdRef = useRef<string | null>(null);

  const entitydatalist = useSelector(
    (state: RootStateOrAny) => state.user.entitydatalist,
  );

  // Handle edit popup
  const [huddleName, setHuddleName] = useState(entityData?.name || "");
  const [huddleDescription, setHuddleDescription] = useState(
    entityData?.profile?.text || "",
  );
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [showEditLoader, setShowEditLoader] = useState(false);

  //// Huddles unReadCounts
  //const [unReadConvo, setUnReadConvo] = useState<any[]>([]);
  //const userAlertList = useSelector((state: RootStateOrAny) => {
  //  const alerts = state?.alerts?.alert || [];
  //  return Array.isArray(alerts[0]) ? alerts[0] : alerts; // flatten if wrapped
  //});

  //useEffect(() => {
  //  if (!userAlertList?.length) {
  //    setUnReadConvo([]);
  //    return;
  //  }

  //  const unReadconvoData = userAlertList.filter(
  //    (x: any) =>
  //      x?.actionTaken === undefined &&
  //      x?.data?.feed?.type === "GroupConvo" &&
  //      (x?.alertType === "NewDM" || x?.alertType === "ReplyDM") &&
  //      x?.data?.person?.id !== currentUser?.id
  //  );

  //  setUnReadConvo(unReadconvoData);
  //}, [userAlertList]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;

      if (
        menuRef.current &&
        !menuRef.current.contains(target) &&
        menuIconRef.current &&
        !menuIconRef.current.contains(target)
      ) {
        setIsMenuOpen(false);
      }
    };

    if (isMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMenuOpen]);

  const handleEdit = () => {
    setHuddleName(entityData?.name || "");
    setHuddleDescription(entityData?.profile?.text || "");
    setShowEditPopup(true);
  };

  const handleCancel = () => {
    setHuddleName(entityData?.name || "");
    setHuddleDescription(entityData?.profile?.text || "");
    setShowEditPopup(false);
  };

  const handleUpdate = async () => {
    if (!entityData) {
      console.error("No entityData to update");
      return;
    }

    setShowEditLoader(true);

    try {
      let huddleData: AV.IAVEntity = { ...entityData };
      huddleData.name = huddleName;
      huddleData.profile = {
        ...(huddleData.profile ?? {}),
        text: huddleDescription.trim(),
      };

      // Update huddle entity
      huddleData = await AV.AVEntity.save(huddleData);

      // Reset redux states
      //let entityHuddleData: AV.IAVEntity = await AV.AVEntity.get(
      //  AV.AVEntity.getFk(huddleData),
      //);
      //console.log("Entity Huddle Data", entityHuddleData);

      let orgIndex = currentUser?.orgs?.findIndex(
        (x) => x.id === huddleData.id,
      );
      if (orgIndex !== -1) {
        currentUser.orgs[orgIndex] = {
          ...currentUser.orgs[orgIndex],
          title: huddleName,
        };
        dispatch(setUser(currentUser));
      }

      const idx = entitydatalist?.findIndex((x) => x?.id === huddleData?.id);
      if (idx !== -1) entitydatalist[idx] = huddleData;
      dispatch(setEntitydataAction(entitydatalist));
      setEntityData(huddleData);
      setfilesList(huddleData?.files ?? null);

      setHuddleName("");
      setHuddleDescription("");
      setShowEditPopup(false);
    } catch (error) {
      console.error("Error creating huddle:", error);
    } finally {
      setShowEditLoader(false);
    }
  };

  const handleConfirmDelete = () => {
    setisConfirmDelete(true);
    setConfirmationText(
      entityData?.status !== "Deleted"
        ? Loc.currentLang.menu.areYouSureWantToDelete
        : Loc.currentLang.menu.areYouSureWantToRestore,
    );
    //setItemSelect(entityData);
    setSelectType("DeleteHuddle");
  };

  const handleDelete = async () => {
    if (!entityData) {
      console.error("No entityData to delete/undelete");
      return;
    }
    setShowEditLoader(true);

    const fk = AV.AVBase.getFk(entityData);

    if (entityData.status === "Deleted") {
      // UNDELETE
      await AV.AVEntity.unDelete(fk);

      // Refresh entity from server
      const updatedEntity: AV.IAVEntity = await AV.AVEntity.get(fk);
      const idx = entitydatalist?.findIndex((x) => x?.id === updatedEntity?.id);
      if (idx !== -1) entitydatalist[idx] = updatedEntity;

      dispatch(setEntitydataAction(entitydatalist));
      setEntityData(updatedEntity);

      //Un-Hide org from current user
      const orgIdx = currentUser?.orgs?.findIndex(
        (x) => x?.id === entityData?.id,
      );
      if (orgIdx !== undefined && orgIdx !== -1) {
        delete currentUser!.orgs![orgIdx].hidden;
        currentUser!.orgs![orgIdx].status = "";
        dispatch(setUser(currentUser));
      }
    } else {
      // DELETE
      await AV.AVEntity.delete(fk);

      entityData.status = "Deleted";
      const idx = entitydatalist?.findIndex((x) => x?.id === entityData?.id);
      if (idx !== -1) entitydatalist[idx] = entityData;

      dispatch(setEntitydataAction(entitydatalist));
      setEntityData(entityData);

      // Hide org from current user
      const orgIdx = currentUser?.orgs?.findIndex(
        (x) => x?.id === entityData?.id,
      );
      if (orgIdx !== undefined && orgIdx !== -1) {
        currentUser!.orgs![orgIdx].hidden = true;
        currentUser!.orgs![orgIdx].status = "Deleted";
        dispatch(setUser(currentUser));
      }
    }

    setShowEditLoader(false);
    setisConfirmDelete(false);
  };

  const {
    textSearchRef,
    mdlCreateConvoVisible,
    setMdlCreateConvoVisible,
    toFK,
    searchInput,
    filteredResults,
    showSearch,
    showFilePicker,
    handleCreateModel,
    searchItems,
    handleSentToProfile,
    handleSendMessage,
    setConvoLoading,
    isLoading,
    handleSubject,
    subject,
    handleMessage,
    handleRemoveItem,
    getImageGalleryFromFilePickerCreateConvo,
    mdlConvoVisible,
    convoSubject,
    setMdlConvoVisible,
    convoPost,
    convo,
    showConvoFilePicker,
    handleGetConvo,
    handleSendConvoMessage,
    replyValue,
    setreplyValue,
    handleChatMessage,
    media,
    value,
    profile,
    Setprofile,
    setValue,
    Loading,
    images,
    setImages,
    isDelete,
    setIsdelete,
    setDeletedImages,
    setUpdateConvoImage,
    setUpdateConvoVideo,
    videoUrls,
    setvideos,
    handleImages,
    handleVoice,
    handleFilePicker,
    onRefresh,
    setSubject,
    settoFK,
    handlePublish,
    setIsHide,
    isHide,
    isImageProcessing,
    setMedia,
    refConvoList,
    setShowConvoFilePicker,
    HandleEditSet,
    handleUpdatePost,
    itemEdit,
    setItemEdit,
    editingImage,
    setEditingImage,
    setConvoPost,
    scrollToMessageWithDelay,
    fetchloading,
    setSearchInput,
    setShowSearch,
    imageInputRef,
    setConvoSubject,
    setConvos,
    typingUserName,
    setIsOpenBox,
    setIsOpenCemera,
    handleOpenPicker,
    setExternalLink,
    HandleAddOneDrive,
    setShowExternalLinkInput,
    showExternalLinkInput,
    HandleAddDropBoxLink,
    isOpenBox,
    isOpenCemera,
    HandleAddExternalUrl,
    handleExternalLink,
    externalLink,
    camera,
    isSetText,
    TriggerOpenConvo,
    setIsTriggerOpenConvo,
    isYoutube,
    setIsYouTube,
    setChatMessage,
    shrink,
    setShrink,
    translateItem,
    handleTranslateText,
    handleShowOriginalText,
    setIsOneDriveData,
    showInsufficientCredits,
    setShowInsufficientCredits,
    scrollRef,
    prevScrollHeightRef,
    prevScrollTopRef,
    loadingOldMessagesRef,
    messagesEndRef,
    setupSignalRConnection,
    handleSendSingleChat,
    cameraMode,
    setCameraMode,
    webcamRef,
    recording,
    setRecording,
    duration,
    setDuration,
    formatDuration,
    toggleMode,
    isCancelledRef,
    handleCameraPhotoCapture,
    handleStartRecording,
    handleStopRecording,
    onClose,
    addLinkLoad,
    setAddLinkLoad,
    editorRef,
    useRichText,
    setUseRichText,
    rteValue,
    setRteValue,
    toolbarOptions,
    isExpanded,
    setIsExpanded,
    setPostPopupExpanded,
    bgColor,
    setBgColor,
    bgImage,
    setBgImage,
    bgImgWidth,
    setBgImgWidth,
    bgImgHeight,
    setBgImgHeight,
    clickedUrl,
    setClickedUrl,
    showConfirmLinkPopup,
    setShowConfirmLinkPopup,
  } = useConvoChat();

  const handleuserRedirect = async (profile) => {
    setShowConvoListModal(false);
    setMdlConvoVisible(false);
    setMdlCreateConvoVisible(false);
    setConvoLoading(false);
    props?.setIsOpenConvo(false);
    navigate(`/profile/${profile?.id}/${profile?.region}`, {
      state: { user: profile },
    });
  };

  // Add this handler
  const onEmojiClick = (event, emojiObject) => {
    // Handle emoji click
    const newVal = value + emojiObject.emoji;
    setValue(newVal);
    setChatMessage(newVal);
    setShrink(newVal?.trim()?.length > 0 ? true : false);
  };

  const SimpleLinkPreview = ({ url }) => {
    return (
      <div className="link-preview-wrapper">
        <div className="link-preview-image">
          <img src={url?.orgFile} alt="images" />
        </div>
        <div className="link-preview-content">
          <Pressable onPress={() => Linking.openURL(url?.linkURL)}>
            <p className="link-url">{url?.linkURL}</p>
          </Pressable>
        </div>
      </div>
    );
  };

  useEffect(() => {
    let img: AV.IMedia[] = [];
    let videoUrl: AV.IMedia[] = [];
    let docsUrl: AV.IMedia[] = [];
    setDeletedImages([]);
    if (itemEdit?.media) img.push(itemEdit.media);

    itemEdit?.galleryPost?.map((item1) => {
      if (item1?.media) img.push(item1.media);
    });
    if (img?.length > 0) {
      setShowConvoFilePicker(true);
      setEditingImage(true);
      setImages(img);
    }

    if (videoUrl?.length > 0) {
      setShowConvoFilePicker(true);
      setEditingImage(true);
      setvideos(videoUrl);
    }
  }, [itemEdit]);

  const RenderImages = ({
    images,
    itemEdit,
    setImages,
    setDeletedImages,
    setUpdateConvoImage,
    setUpdateConvoVideo,
    media,
    setMedia,
    isImageProcessing,
    editingImage,
    setEditingImage,
    setIsdelete,
    useRichText = false,
    isExpanded = false,
  }) => {
    const [isAPICall, setIsAPICall] = useState(false);
    const [isConfirm, setIsConfirm] = useState(false);
    const [removedItems, setRemovedItems] = useState<any | null>(null);

    useEffect(() => {}, [editingImage]);

    let imgmedia: AV.IMedia[] = [];
    let vidmedia: AV.IMedia[] = [];

    images?.forEach((img) => {
      if (editingImage) {
        if (images?.length > 0) {
          if (img) {
            imgmedia?.push(img);
          } else {
            vidmedia.push(img);
          }
        }
      } else {
        if (images?.length > 0) {
          if (img) {
            imgmedia?.push(img);
          }
        } else vidmedia.push(img);
      }
    });

    const handleRemoveItem = (item) => {
      setIsdelete?.(true);
      setIsConfirm(true);
      setRemovedItems(item);
    };

    const deleteImage = (item?: any) => {
      const deleteItem = removedItems ?? item;
      if (!deleteItem) return;

      setDeletedImages((prev) => [...prev, deleteItem?.id]);

      let filterImages = images?.filter((x, i) => x?.id !== deleteItem?.id);
      setImages(filterImages);

      setUpdateConvoImage(
        filterImages?.filter((x, i) => !x?.type?.startsWith("video")),
      );

      const filterVideos = filterImages?.filter(
        (x, i) => x?.type?.startsWith("video") && x?.id !== deleteItem?.id,
      );
      if (filterVideos) {
        setUpdateConvoVideo(filterVideos);
      }

      let filterMedia = media?.filter((x, i) => x?.id !== deleteItem?.id);
      setMedia(filterMedia);

      if (
        (itemEdit?.id?.length === undefined || itemEdit?.id?.length === 0) &&
        filterImages?.length === 0
      ) {
        //setValue("");
        setItemEdit("");
        //setShrink(false);
        setEditingImage(false);
        setShowConvoFilePicker(false);
      }

      setIsAPICall(false);
      setIsdelete?.(false);
      setIsConfirm(false);
    };

    return (
      <>
        <VStack px={1}>
          <HStack space={1} alignItems={"center"}></HStack>
          <HStack overflow="scroll" maxWidth={useRichText ? "100%" : "600px"}>
            {images.map((item, i) => {
              return (
                <Box
                  key={item?.id || i}
                  m={1}
                  width={item?.type?.startsWith("audio") ? "205px" : "120px"}
                  height={"120px"}
                >
                  <Box
                    position={"absolute"}
                    top={1}
                    right={1}
                    bgColor={"white"}
                    rounded={"full"}
                    zIndex={100}
                  >
                    {!isImageProcessing && (
                      <AVCancel
                        size={"10px"}
                        callback={() => {
                          handleRemoveItem(item);
                        }}
                        color={"#000000"}
                      />
                    )}
                  </Box>
                  {item?.type?.startsWith("image") ||
                  (!item?.id &&
                    typeof item === "string" &&
                    item.startsWith("data:image")) ||
                  item?.type == "Onedrive" ||
                  item?.type == "dropbox" ? (
                    <img
                      src={
                        item?.type === "dropbox"
                          ? item?.orgFile
                          : item?.linkURL
                            ? item?.linkURL
                            : !item?.id &&
                                typeof item === "string" &&
                                item.startsWith("data:image")
                              ? item
                              : Media.getURL(item)
                      }
                      alt=""
                      className="Image"
                      width="100%"
                      height="100%"
                      style={{ objectFit: "cover" }}
                    />
                  ) : item?.type === "iframe" ? (
                    <iframe
                      src={item?.linkURL}
                      width="100%"
                      height="100%"
                    ></iframe>
                  ) : item?.type == "linkPreview" ? (
                    <SimpleLinkPreview url={item} />
                  ) : item?.type?.startsWith("application") ? (
                    <img
                      src={
                        (item?.type === "application/pdf" && settings.pdf) ||
                        ((item?.type === "application/msword" ||
                          item?.type ===
                            "application/vnd.openxmlformats-officedocument.wordprocessingml.document") &&
                          settings.word) ||
                        ((item?.type === "application/vnd.ms-powerpoint" ||
                          item?.type ===
                            "application/vnd.openxmlformats-officedocument.presentationml.presentation") &&
                          settings.powerpoint) ||
                        ((item?.type === "application/vnd.ms-excel" ||
                          item?.type ===
                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") &&
                          settings.excel) ||
                        settings.file
                      }
                      alt=""
                      className="Image"
                      width="100%"
                      height="100%"
                      style={{
                        objectFit: "contain",
                        backgroundColor: "#eeeeee",
                      }}
                    />
                  ) : item?.type === "text/plain" ? (
                    <img
                      src={settings.file}
                      alt=""
                      className="Image"
                      width="100%"
                      height="100%"
                      style={{
                        objectFit: "contain",
                        backgroundColor: "#eeeeee",
                      }}
                    />
                  ) : item?.type?.startsWith("audio") ? (
                    <VoiceMessage
                      audioUrl={Media.getURL(item)}
                      onRecordingComplete={() => {}}
                    />
                  ) : (
                    <div className="processing-container">
                      <img
                        src={Media.getVideoPicURL(item)}
                        alt=""
                        className="Image"
                        width="100%"
                        height="100%"
                        style={{
                          objectFit: "contain",
                          backgroundColor: "#eeeeee",
                        }}
                      />
                      <Box
                        position="absolute"
                        top={"50%"}
                        left={"50%"}
                        style={{
                          transform: [{ translateX: -30 }, { translateY: -30 }],
                        }}
                      >
                        <VideoIcon size={"60px"} color={"white"} />
                      </Box>
                    </div>
                  )}
                </Box>
              );
            })}
          </HStack>
        </VStack>

        {isConfirm && (
          <AVConfirmationModal
            showconfirmationPopup={isConfirm}
            setshowconfirmationPopup={setIsConfirm}
            setIsdelete={setIsdelete}
            Confirmationtext={
              Loc.currentLang.confirmationText.areYouSureYouWantToRemoveThisItem
            }
            type={"ChatImageRemove"}
            item={undefined}
            function={deleteImage}
            isLoader={isAPICall}
          />
        )}
      </>
    );
  };

  const getItemLayout = (data, index) => ({
    length: itemHeights[index] || 0, // Use itemHeights[index], if available, otherwise default to 0
    offset: itemHeights
      .slice(0, index)
      .reduce((acc, height) => acc + height, 0),
    index,
  });

  const ReplyLoadMedia = ({ item, isDetail = false }) => {
    const [imageUrls, setImagesUrl] = useState<AV.IMedia[]>([]);
    const [videoUrls, setVideoUrl] = useState<AV.IMedia[]>([]);
    const [media, setMedia] = useState<any>([]);

    useEffect(() => {
      setMedia([]);
      if (
        item?.media?.storeId &&
        (item?.galleryPost?.length == 0 ||
          item?.galleryPost?.length == undefined)
      ) {
        imageUrls.push(item?.media);
        setMedia(imageUrls);
      } else if (item?.galleryPost?.length > 0) {
        // Loop through gallery posts and add media
        for (let i = 0; i < item?.galleryPost?.length; i++) {
          imageUrls.push(item?.galleryPost[i].media);
        }
        setMedia(imageUrls);
      }
    }, []);

    return (
      <>
        <VStack px={1}>
          <HStack overflow="scroll" maxWidth={"400px"}>
            {media.map((item, i) => {
              return (
                <Box
                  m={1}
                  width={item?.type?.startsWith("audio") ? "310px" : "100px"}
                  height={item?.type?.startsWith("audio") ? "42px" : "72px"}
                >
                  <Box
                    position={"absolute"}
                    top={1}
                    right={1}
                    bgColor={"white"}
                    rounded={"full"}
                    zIndex={100}
                  ></Box>
                  {item?.type?.startsWith("image") ||
                  (!item?.id &&
                    typeof item === "string" &&
                    item.startsWith("data:image")) ||
                  item?.type == "Onedrive" ||
                  item?.type == "dropbox" ? (
                    <img
                      src={
                        item?.type === "dropbox"
                          ? item?.orgFile
                          : item?.linkURL
                            ? item?.linkURL
                            : !item?.id &&
                                typeof item === "string" &&
                                item.startsWith("data:image")
                              ? item
                              : Media.getURL(item)
                      }
                      alt=""
                      className="Image"
                      width="100%"
                      height="100%"
                      style={{ objectFit: "cover" }}
                    />
                  ) : item?.type === "iframe" ? (
                    <iframe
                      src={item?.linkURL}
                      width="100%"
                      height="100%"
                    ></iframe>
                  ) : item?.type == "linkPreview" ? (
                    <SimpleLinkPreview url={item} />
                  ) : item?.type?.startsWith("application") ? (
                    <img
                      src={
                        (item?.type === "application/pdf" && settings.pdf) ||
                        ((item?.type === "application/msword" ||
                          item?.type ===
                            "application/vnd.openxmlformats-officedocument.wordprocessingml.document") &&
                          settings.word) ||
                        ((item?.type === "application/vnd.ms-powerpoint" ||
                          item?.type ===
                            "application/vnd.openxmlformats-officedocument.presentationml.presentation") &&
                          settings.powerpoint) ||
                        ((item?.type === "application/vnd.ms-excel" ||
                          item?.type ===
                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") &&
                          settings.excel) ||
                        settings.file
                      }
                      alt=""
                      className="Image"
                      width="100%"
                      height="100%"
                      style={{
                        objectFit: "contain",
                        backgroundColor: "#eeeeee",
                      }}
                    />
                  ) : item?.type === "text/plain" ? (
                    <img
                      src={settings.file}
                      alt=""
                      className="Image"
                      width="100%"
                      height="100%"
                      style={{
                        objectFit: "contain",
                        backgroundColor: "#eeeeee",
                      }}
                    />
                  ) : item?.type?.startsWith("audio") ? (
                    <HStack
                      space={2}
                      width={"100%"}
                      marginLeft={20}
                      justifyContent={"center"}
                      alignItems="center"
                      bg="rgba(0,0,0,0.05)"
                      p={2}
                      borderRadius="md"
                    >
                      <MicIcon size="24px" color="AVColor.primary" />

                      <Text color="#32AE78" fontSize="sm">
                        {Loc.currentLang.menu.voiceMessage}
                      </Text>
                      {/* <Text color="gray.500" fontSize="xs">
                      {formatDuration(media?.duration || 0)}
                    </Text> */}
                    </HStack>
                  ) : (
                    <div className="processing-container">
                      <img
                        src={Media.getVideoPicURL(item)}
                        alt=""
                        className="Image"
                        width="100%"
                        height="100%"
                        style={{
                          objectFit: "contain",
                          backgroundColor: "#eeeeee",
                        }}
                      />
                      <Box
                        position="absolute"
                        top={"50%"}
                        left={"50%"}
                        style={{
                          transform: [{ translateX: -30 }, { translateY: -30 }],
                        }}
                      >
                        <VideoIcon size={"60px"} color={"white"} />
                      </Box>
                    </div>
                  )}
                </Box>
              );
            })}
          </HStack>
        </VStack>
      </>
    );
  };

  useEffect(() => {
    let isMounted = true;

    setConvos([]);
    setConvoPost([]);
    setValue("");
    //setEntityData("");
    //setfilesList([]);
    console.log("huddleItem", isHuddleData);

    if (
      isMounted &&
      isHuddleData?.id?.trim().length > 0 &&
      isHuddleData?.data?.trim().length > 0
    ) {
      const postData = userconvo?.filter(
        (x) => x?.id === isHuddleData?.data ?? "",
      );

      if (postData?.length > 0) {
        currentConvoIdRef.current = postData[0].id; // Track the current chat ID
        handleGetConvo(postData[0]);
        getConvo(postData[0]);
        GetEntity();
      } else {
        currentConvoIdRef.current = isHuddleData?.data;
        getConvo();
        GetEntity();
      }
    }

    setActiveTab(
      location?.state?.type
        ? location?.state?.type
        : Loc.currentLang.activity.headers.chat,
    );

    return () => {
      isMounted = false;
    };
  }, [isHuddleData]);

  const GetEntity = async () => {
    let EntityItem = entitydatalist.filter(
      (x: AV.IAVEntity) => x?.id === isHuddleData?.id,
    );
    if (EntityItem?.length === 0) {
      let entityData: AV.IAVEntity = await AV.AVEntity.get(isHuddleData);
      setEntityData(entityData);
      entitydatalist.push(entityData);
      dispatch(setEntitydataAction(entitydatalist));
      setfilesList(entityData?.files ?? null);

      const isAdminOrStaff = //entityData?.status === "Deleted"
        //  ? false
        //  :
        (entityData as any)?.staff?.some(
          (x) => x?.id === currentUser?.id, //&& x?.role?.isOwner,
        );
      setIsAdminView(isAdminOrStaff);
    } else {
      setEntityData(EntityItem[0]);
      let entityData: AV.IAVEntity = await AV.AVEntity.get(isHuddleData);
      const index = entitydatalist?.findIndex(
        (x: AV.IAVEntity) => x?.id === entityData?.id,
      );
      if (index !== -1) {
        entitydatalist[index] = entityData;
        dispatch(setEntitydataAction(entitydatalist));
        setEntityData(entityData);
        setfilesList(entityData?.files ?? null);
      }

      const isAdminOrStaff = //entityData?.status === "Deleted"
        //  ? false
        //  :
        (entityData as any)?.staff?.some(
          (x) => x?.id === currentUser?.id, //&& x?.role?.isOwner,
        );
      setIsAdminView(isAdminOrStaff);
    }
  };

  // Converts list data to tree structure
  const list_to_tree = (list: any) => {
    var map: any = {},
      node: any,
      roots: any = [],
      i;

    for (i = 0; i < list?.length; i += 1) {
      map[list[i]?.id] = i; // initialize the map
      if (list[i]?.children?.length === 0 || !list[i]?.children)
        list[i]["children"] = []; // initialize the children
      if (list[i]?.galleryPost?.length === 0 || !list[i]?.galleryPost)
        list[i]["galleryPost"] = [];
      list[i]["ReplyPost"] = [];
    }

    for (i = 0; i < list?.length; i += 1) {
      node = list[i];
      if (node.parentPost !== undefined) {
        if (
          list[map[node.parentPost]]?.gallery?.items?.filter(
            (x: any) => x === node.id,
          )?.length > 0 &&
          node.gallery == undefined
        ) {
          let excitingpost = list[map[node.parentPost]]?.galleryPost?.filter(
            (x: any) => x?.id === node?.id,
          );
          if (excitingpost?.length === 0 || excitingpost === undefined)
            list[map[node.parentPost]]?.galleryPost.push(node);
        } else {
          let PPost = list.filter((x: any) => x?.id === node?.parentPost);
          node.ReplyPost.push(PPost[0]);
          roots.push(node);
        }
      } else {
        roots.push(node);
      }
    }
    return roots;
  };

  const getConvo = async (item?: any) => {
    let currentConvo = item;
    const previousConvoId = currentConvoIdRef.current;

    // Prepare the conversation feed object
    const convoFeed: AV.IFK = {
      id: isHuddleData?.data,
      pk: isHuddleData?.data,
      region: isHuddleData?.region,
      type: "GroupConvo",
    };

    const param: AV.IFeedParam = {
      feed: convoFeed,
      checkArchive: false,
      forward: true,
      startDate: new Date(0),
    };

    const feedParams: AV.IFeedParam[] = [param];

    // Check if user switched chats
    if (previousConvoId !== currentConvoIdRef.current) {
      return;
    }

    const feedsResponse: any = (await AV.Feed.getAllFeeds(
      feedParams,
    )) as AV.IConversation[];

    // If feed returns no results, exit early
    if (!feedsResponse?.[0]) return;

    // Check if user switched chats
    if (previousConvoId !== currentConvoIdRef.current) {
      return;
    }

    // Sort privateIds by date descending (latest first)
    let filteredPrivateIds = _.orderBy(
      feedsResponse[0].privateIds,
      ["date"],
      ["desc"],
    );

    const group: Record<string, AV.IPostListParam> = {};

    // Group privateIds under the same convo ID for batching
    filteredPrivateIds.forEach(({ id }) => {
      if (!group[isHuddleData?.data]) {
        group[isHuddleData?.data] = { feed: convoFeed, ids: [] };
      }
      group[isHuddleData?.data].ids!.push(id);
    });

    // Flatten the batched group to individual { feed, id } objects
    const batched: AV.IPostListParam[] = Object.values(group);
    const flattened = batched.flatMap(({ feed, ids }) =>
      (ids ?? []).map((id) => ({ feed, id })),
    );

    // Limit to first 20 posts per batch
    const first20 = flattened.slice(0, 20);

    // Group again for Feed.getAllPosts format
    const groupByFeed = (items: { feed: AV.IFK; id: string }[]) => {
      const map = new Map<string, { feed: AV.IFK; ids: string[] }>();
      items.forEach(({ feed, id }) => {
        if (!feed?.id) return;

        if (!map.has(feed.id)) {
          map.set(feed.id, { feed, ids: [] });
        }
        map.get(feed.id)!.ids.push(id);
      });
      return Array.from(map.values());
    };

    const firstBatch = groupByFeed(first20);

    // Check if user switched chats
    if (previousConvoId !== currentConvoIdRef.current) {
      return;
    }

    // Fetch the posts by ID from Feed
    let fetchPosts =
      firstBatch.length > 0 ? await AV.Feed.getAllPosts(firstBatch) : [];

    // Check if user switched chats
    if (previousConvoId !== currentConvoIdRef.current) {
      return;
    }

    // Fetch replies if posts are threaded
    if (Array.isArray(fetchPosts)) {
      fetchPosts = await fetchReplyPosts(fetchPosts, firstBatch);
    }

    // Merge fetched posts into current user conversation
    let convoChat = userconvo?.find((x) => x?.id === isHuddleData?.data);

    // Merge posts and remove duplicates
    let allFeeds = [...(convoChat?.posts ?? []), ...fetchPosts];
    allFeeds = _.uniqBy(allFeeds, "id");

    // Convert to tree structure for threaded conversations
    allFeeds = list_to_tree(allFeeds);

    // Sort posts by createDate descending (latest first)
    allFeeds = allFeeds.sort(
      (a, b) =>
        new Date(b.createDate).getTime() - new Date(a.createDate).getTime(),
    );

    // Check again before updating state
    if (previousConvoId !== currentConvoIdRef.current) {
      return;
    }

    // Update the post list in local and redux state
    if (convoChat?.id?.length > 0) convoChat.posts = allFeeds;
    if (currentConvo?.id?.length > 0) {
      currentConvo.posts = allFeeds;
      //convoChat.privateIds = currentConvo.privateIds;
    } else if (currentConvo !== undefined) {
      currentConvo.posts = allFeeds;
    }

    const index = userconvo?.findIndex((x) => x.id === isHuddleData?.data);
    if (index !== -1) {
      userconvo[index] =
        convoChat?.id?.length > 0 ? convoChat : feedsResponse[0];
    } else if (feedsResponse.length > 0) {
      let usercon: any = [];
      if (userconvo?.length > 0) usercon = userconvo;

      feedsResponse[0].posts = allFeeds;
      setConvos(feedsResponse[0]);
      usercon.unshift(feedsResponse[0]);
      dispatch(setConvo(usercon));
    }

    handleGetConvo(
      currentConvo?.id?.length > 0 ? currentConvo : feedsResponse[0],
    ); // Refresh UI
  };

  // Fetch reply posts
  async function fetchReplyPosts(
    postList: AV.IPost[],
    postsToFetch: AV.IPostListParam[],
  ): Promise<AV.IPost[]> {
    const replyPostIds = postList
      .filter((x) => Array.isArray(x.posts) && x.posts.length > 0) // Only posts with nested replies
      .map((x) => ({ id: x.id, pk: x.pk, posts: x.posts })); // Collect their post IDs and pk

    if (replyPostIds.length === 0) return postList; // No replies to fetch

    const replyPostListParams: AV.IPostListParam[] = [];
    const uniquePks = [
      ...new Set(
        replyPostIds.map((r) => r.pk).filter((pk): pk is string => !!pk),
      ),
    ]; // Unique pk list

    // Match original fetch request with replies using pk
    uniquePks.forEach((pk) => {
      const matchedFeed = postsToFetch.filter((x) => x.feed.pk === pk);
      if (matchedFeed.length > 0) {
        replyPostListParams.push({
          feed: matchedFeed[0].feed,
          ids: replyPostIds.find((x) => x.pk === pk)?.posts || [],
        });
      }
    });

    const replyPostList = await AV.Feed.getAllPosts(replyPostListParams); // Fetch reply posts
    return _.uniqBy([...postList, ...replyPostList], "id"); // Merge with original and dedupe
  }

  const RenderMembersTab = ({
    entityData,
    currentUser,
    userconvo,
    handleSendSingleChat,
    setIsConvoData,
    setIsOpenConvo,
    setEntitydata,
  }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const dimensions = useWindowDimension();
    const isMobile = dimensions?.width <= 500;

    const [isOpen, setIsOpen] = useState(false);
    const [isMemberData, setIsMemberData] = useState("");
    const [isSlienceLoad, setIsSlienceLoad] = useState(false);
    const [unSlienceLoad, setIsUnSlienceLoad] = useState(false);
    const [isMemberTab, setIsMemberTab] = useState<string>("");
    const [selectTypeMember, setSelectTypeMember] = useState<string>();
    const [itemSelectMember, setItemSelectMember] = useState<any>("");
    const [memberList, setMemberList] = useState<AV.ILink[]>(
      entityData?.members,
    );
    const [contactMemberList, setContactMemberList] = useState<any>();
    const [menuMember, setMenuMember] = useState<any>("");
    const [newNameMember, setNewNameMember] = useState<string>("");
    const [newMailMember, setNewMailMember] = useState<string>("");
    const [isEditMemberDetails, setIsEditMemberDetails] = useState(false);
    const [isConfirmDeleteMember, setisConfirmDeleteMember] = useState(false);
    const [confirmationTextMember, setConfirmationTextMember] = useState("");
    const [showFileuploadModalMember, setshowFileuploadModalMember] =
      useState(false);
    const [showAddProfileModalMember, setShowAddProfileModalMember] =
      useState(false);

    const menuRefs = useRef(null);
    useOutsideAlerter(menuRefs);

    function useOutsideAlerter(ref) {
      React.useEffect(() => {
        let isMounted = true;
        if (isMounted) {
          function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
              setIsOpen(false);
            }
          }
          document.addEventListener("mousedown", handleClickOutside);
          return () => {
            document.removeEventListener("mousedown", handleClickOutside);
          };
        }
        return () => {
          isMounted = false;
        };
      }, [ref]);
    }

    useEffect(() => {
      //const isAdminOrStaff = entityData?.staff?.some(
      //  (x) => x?.id === currentUser?.id //&& x?.role?.isOwner,
      //);
      //setIsAdminView(isAdminOrStaff);
      setIsMember(true);
      setMemberList(entityData?.members);
    }, [entityData, currentUser]);

    const HandleSlience = async (item) => {
      setIsSlienceLoad(true);
      await AV.AVEntity.silence(AV.AVEntity.getFk(currentUser), item);
      let userUpdate = await AV.Person.getSelf();
      if (userUpdate?.id) dispatch(setUser(userUpdate));
      setIsSlienceLoad(false);
      setIsOpen(!isOpen);
    };

    const HandleUnSlience = async (item) => {
      setIsUnSlienceLoad(true);
      await AV.AVEntity.UnSilence(AV.AVEntity.getFk(currentUser), item);
      let userUpdate = await AV.Person.getSelf();
      if (userUpdate?.id) dispatch(setUser(userUpdate));
      setIsUnSlienceLoad(false);
      setIsOpen(!isOpen);
    };

    const HandleRemoveMember = (item) => {
      setisConfirmDeleteMember(true);
      setConfirmationTextMember(Loc.currentLang.menu.deleteMemberConfirmText);
      setItemSelectMember(item);
      setSelectTypeMember("DeleteMember");
    };

    const HandleDeleteMember = async () => {
      setShowEditLoader(true);

      let removeMember: AV.IAVEntity = await AV.OrgBase.removeMember(
        AV.AVEntity.getFk(entityData),
        {
          id: itemSelectMember.id,
          pk: itemSelectMember.pk,
          type: "Person",
        },
      );

      if (removeMember !== null) {
        setEntitydata(removeMember);
        setMemberList(removeMember?.members ?? []);
      }

      setShowEditLoader(false);
      setisConfirmDeleteMember(false);
    };

    const findPersonInChats = (conversations, personToCheck) => {
      return conversations.find(
        (convo) =>
          convo?.subject === "" &&
          convo?.people?.some(
            (person) =>
              person?.id === personToCheck?.id &&
              person?.pk === personToCheck?.pk,
          ),
      );
    };

    const handleChat = async (item: any) => {
      setIsMemberTab(item);
      setIsRotate(true);
      let People: any = [];
      People?.push(item);

      let valid = await findPersonInChats(userconvo, item);
      if (valid?.id !== undefined) {
        setIsConvoData(valid?.id);
        setIsRotate(false);
        setIsOpenConvo(true);
        return;
      }

      let chatData = await handleSendSingleChat(People);
      if (chatData) {
        setIsConvoData(chatData?.id);
      }

      setIsRotate(false);
      setIsOpenConvo(true);
      setIsMemberTab(item);
    };

    const handleUpdateMember = async (item) => {
      let roles = entityData?.members?.filter((x) => x?.name === "Staff")[0];
      menuMember.role = roles;

      if (newNameMember?.trim()?.length > 0) menuMember.name = newNameMember;
      if (newMailMember?.trim()?.length > 0) menuMember.email = newMailMember;

      setMenuMember(menuMember);
      contactMemberList[contactMemberList.indexOf(item)] = menuMember;
      setContactMemberList(contactMemberList);

      setMenuMember("");
      setNewNameMember("");
      setNewMailMember("");
      setIsEditMemberDetails(false);
    };

    const handleRemoveMember = async (item) => {
      setContactMemberList(contactMemberList?.filter((x) => x !== item));
    };

    const handleAddContactMemberList = async () => {
      setShowEditLoader(true);
      setIsEditMemberDetails(false);

      let member: AV.IAVEntity = await AV.AVEntity.addMembers(
        AV.AVEntity.getFk(entityData),
        contactMemberList,
      );
      if (member) {
        setMemberList(member?.members ?? []);
      }

      setShowEditLoader(false);
      setshowFileuploadModalMember(false);
      setShowAddProfileModalMember(false);
    };

    return (
      <Box
        minHeight="340px"
        borderRadius={5}
        backgroundColor="AVColor.white"
        shadow={1}
        flex={1}
        mb={3}
      >
        <VStack>
          <HStack alignItems="center" justifyContent="space-between">
            <Text
              fontWeight="500"
              marginLeft="15px"
              fontSize="22px"
              color="AVColor.primary"
              py="12px"
            >
              {Loc.currentLang.menu.members}
            </Text>

            <HStack alignItems={"center"} pr={2}>
              <HStack>
                <Tooltip
                  label={Loc.currentLang.helpText.club.memberTab}
                  w={200}
                >
                  <Box
                    marginRight={"10px"}
                    p={"9px"}
                    display={memberList?.length > 0 ? "" : "none"}
                    shadow={1}
                    backgroundColor={"AVColor.liteBg"}
                    rounded={"full"}
                  >
                    <img src={helping} height={"17px"} width={"17px"} />
                  </Box>
                </Tooltip>

                {isAdminView && (
                  <Button
                    isDisabled={!isOnline}
                    rounded="full"
                    bgColor="gray.100"
                    _hover={{ bgColor: "gray.50" }}
                    shadow={1}
                    p="10px"
                    left={"-5px"}
                    onPress={() => setShowAddProfileModalMember(true)}
                  >
                    <AddIcon size="20px" color="#32AE78" />
                  </Button>
                )}
              </HStack>
            </HStack>
          </HStack>
        </VStack>

        <Divider my={2} zIndex={-3} />

        <HStack flexWrap="wrap" alignSelf="flex-start">
          {memberList?.length > 0 ? (
            memberList.map((item, index) => (
              <MemberCard
                key={index}
                item={item}
                currentUser={currentUser}
                isAdminView={isAdminView}
                isOpen={isOpen}
                isMemberData={isMemberData}
                setIsOpen={setIsOpen}
                setIsMemberData={setIsMemberData}
                HandleSlience={HandleSlience}
                HandleUnSlience={HandleUnSlience}
                HandleRemoveMembers={HandleRemoveMember}
                isSlienceLoad={isSlienceLoad}
                unSlienceLoad={unSlienceLoad}
                isLoading={showEditLoader}
                navigate={navigate}
                menuRefs={menuRefs}
                handleChat={handleChat}
              />
            ))
          ) : (
            <HStack
              width="100%"
              top={isMobile ? "20px" : "0px"}
              padding="10px"
              marginTop={isMobile ? "-10px" : "0px"}
              space={2}
            >
              <img src={inform} style={{ width: "20px", height: "20px" }} />
              {Loc.currentLang.huddles.memberTab}
            </HStack>
          )}
        </HStack>

        {showAddProfileModalMember && (
          <AVPersonaModal
            isMember={isMember}
            isParticipant={false}
            setShowAddProfileModal={setShowAddProfileModalMember}
            isStaff={false}
            Entity={entityData}
            setEntity={setEntitydata}
            setcontactList={setContactMemberList}
            setshowFileuploadModal={setshowFileuploadModalMember}
            setStaffList={undefined}
            setmemberList={setMemberList}
            isPlayer={false}
            setPlayersList={undefined}
            showAddProfileModal={showAddProfileModalMember}
            isTeam={false}
            searchTypes={""}
            setOrgList={undefined}
            setGroupList={undefined}
            isEditEntireSeries={false}
            seriesEvent={undefined}
          />
        )}

        {isConfirmDeleteMember && (
          <AVConfirmationModal
            showconfirmationPopup={isConfirmDeleteMember}
            setshowconfirmationPopup={setisConfirmDeleteMember}
            Confirmationtext={confirmationTextMember}
            type={selectTypeMember}
            item={itemSelectMember}
            function={HandleDeleteMember}
            isLoader={showEditLoader}
          />
        )}

        {/* FileUploadModal Popup */}
        {showFileuploadModalMember && (
          <Box
            position="fixed"
            bgColor={"AVColor.overlay2"}
            bottom={0}
            right={0}
            top={0}
            left={0}
            zIndex={99}
          >
            <Modal.Content
              bgColor={"#fff"}
              maxWidth={"100%"}
              width={"50%"}
              padding={"24px"}
              minHeight={[500]}
              left={"22%"}
              top={"20%"}
            >
              <HStack fontSize={"24px"} fontWeight={400} marginBottom={"24px"}>
                {Loc.currentLang.menu.members}
              </HStack>

              <VStack
                alignItems={"center"}
                space={4}
                width={"auto"}
                overflowY={"auto"}
                height={"334px"}
                justifyContent={"flex-start"}
              >
                <HStack
                  flexWrap={"wrap"}
                  alignSelf={"flex-start"}
                  space={6}
                  zIndex={-1}
                  justifyContent={"center"}
                  height={"145px"}
                  width={"98%"}
                >
                  {contactMemberList?.map((item, index) => (
                    <React.Fragment key={index}>
                      <HStack
                        alignItems={"center"}
                        borderStyle={"solid"}
                        borderColor={"rgba(0, 0, 0, 0.05)"}
                        borderRadius={"5px"}
                        width={"100%"}
                        height={"40px"}
                      >
                        <HStack width={"85%"}>
                          <HStack marginRight={"10px"} width={"30%"}>
                            {!isEditMemberDetails || menuMember !== item ? (
                              <Text
                                fontWeight="500"
                                numberOfLines={1}
                                ellipsizeMode={"tail"}
                                fontSize={"16px"}
                                textAlign={"left"}
                                color={"#000000"}
                                width={"100%"}
                                textTransform={"capitalize"}
                              >
                                {item?.name}
                              </Text>
                            ) : (
                              <Box width={"80%"} marginTop={"3px"}>
                                <Input
                                  textAlign={"left"}
                                  fontSize={"16px"}
                                  paddingLeft={"0px"}
                                  paddingRight={"0px"}
                                  value={newNameMember}
                                  defaultValue={menuMember?.name}
                                  onChangeText={(e) => setNewNameMember(e)}
                                />
                              </Box>
                            )}
                          </HStack>

                          <HStack width={"48%"} marginRight={"10px"}>
                            {!isEditMemberDetails || menuMember !== item ? (
                              <Text
                                fontSize={"16px"}
                                width={"100%"}
                                numberOfLines={1}
                                ellipsizeMode={"tail"}
                                textAlign={"left"}
                                textTransform={"capitalize"}
                              >
                                {item?.email}
                              </Text>
                            ) : (
                              <Box width={"80%"} marginTop={"3px"}>
                                <Input
                                  textAlign={"left"}
                                  fontSize={"16px"}
                                  paddingLeft={"0px"}
                                  paddingRight={"0px"}
                                  value={newMailMember}
                                  defaultValue={menuMember?.email}
                                  onChangeText={(e) => setNewMailMember(e)}
                                />
                              </Box>
                            )}
                          </HStack>
                        </HStack>

                        <HStack position={"absolute"} right={0} space={3}>
                          {(!isEditMemberDetails || menuMember !== item) && (
                            <Button
                              backgroundColor={"white"}
                              width={"50px"}
                              height={"40px"}
                              isDisabled={showEditLoader}
                              onPress={() => {
                                setMenuMember(item);
                                setNewMailMember(item?.email);
                                setNewNameMember(item?.name);
                                setIsEditMemberDetails(true);
                              }}
                            >
                              <HStack>
                                <Text
                                  fontSize={"16px"}
                                  underline
                                  textAlign={"center"}
                                  color={"#00A7BC"}
                                >
                                  {Loc.currentLang.menu.edit}
                                </Text>
                              </HStack>
                            </Button>
                          )}{" "}
                          {isEditMemberDetails && menuMember === item && (
                            <Button
                              backgroundColor={"white"}
                              width={"50px"}
                              height={"40px"}
                              onPress={() => {
                                handleUpdateMember(item);
                              }}
                            >
                              <HStack>
                                <Text
                                  fontSize={"16px"}
                                  underline
                                  textAlign={"center"}
                                  color={"#00A7BC"}
                                >
                                  {Loc.currentLang.menu.update}
                                </Text>
                              </HStack>
                            </Button>
                          )}
                          <Button
                            backgroundColor={"white"}
                            height={"40px"}
                            width={"50px"}
                            isDisabled={showEditLoader}
                            onPress={() => handleRemoveMember(item)}
                          >
                            <HStack>
                              <Text
                                fontSize={"16px"}
                                underline
                                textAlign={"center"}
                                color={"#DF2827"}
                              >
                                {Loc.currentLang.menu.delete}
                              </Text>
                            </HStack>
                          </Button>
                        </HStack>
                      </HStack>
                      <Divider marginTop={"5px"} />
                    </React.Fragment>
                  ))}
                </HStack>
              </VStack>

              <HStack
                width={"100%"}
                space={5}
                flex={1}
                justifyContent={"flex-end"}
                alignItems={"top"}
                pr={5}
                top={"88%"}
                position="absolute"
                right="10px"
                maxHeight={"200px"}
                padding={0}
                background={"none"}
              >
                <Button
                  background={"#EEEEEE"}
                  borderRadius={15}
                  px={16}
                  height={"40px"}
                  width={"40px"}
                  rounded="full"
                  onPress={() => {
                    setshowFileuploadModalMember(false);
                  }}
                >
                  <Text color={"#000000"}>{Loc.currentLang.menu.cancel}</Text>
                </Button>

                <Button
                  bgColor={"AVColor.primary"}
                  height={"40px"}
                  isLoading={showEditLoader}
                  isLoadingText={Loc.currentLang.menu.saveLoad}
                  width={"40px"}
                  borderRadius={15}
                  px={16}
                  rounded="full"
                  isDisabled={contactMemberList.length === 0}
                  onPress={handleAddContactMemberList}
                >
                  <Text color={"#ffffff"}>{Loc.currentLang.menu.save}</Text>
                </Button>
              </HStack>
            </Modal.Content>
          </Box>
        )}
      </Box>
    );
  };

  const MemberCard = ({
    item,
    currentUser,
    isAdminView,
    isOpen,
    isMemberData,
    setIsOpen,
    setIsMemberData,
    HandleSlience,
    HandleUnSlience,
    HandleRemoveMembers,
    isSlienceLoad,
    unSlienceLoad,
    isLoading,
    navigate,
    menuRefs,
    handleChat,
  }) => {
    let cacheItem = entitydatalist?.find((x: any) => x?.id == item?.id);
    if (cacheItem || currentUser?.id == item?.id)
      item =
        currentUser?.id == item?.id
          ? AV.AVEntity.getLink(currentUser)
          : AV.AVEntity.getLink(cacheItem);

    return (
      <>
        <Box
          key={item.id}
          bgColor={"#fff"}
          borderWidth={"1px"}
          borderColor={"gray.400"}
          zIndex={-3}
          width={"160px"}
          height={"150px"}
          borderRadius={10}
          m={"12px"}
          shadow={1}
        >
          {/*{currentUser?.id !== item?.id && (*/}
          {/*  <Offline>*/}
          {/*    {({ isOffline }) => (*/}
          {/*      <Pressable*/}
          {/*        isDisabled={isOffline}*/}
          {/*        zIndex={999}*/}
          {/*        position={"absolute"}*/}
          {/*        top={"10px"}*/}
          {/*        left={"10px"}*/}
          {/*        onPress={() => handleChat(item)}*/}
          {/*      >*/}
          {/*        {isRotate && item?.id === isMemberTab?.id ? (*/}
          {/*          <div className="loading"></div>*/}
          {/*        ) : (*/}
          {/*          <GroupChatIcon size={23} color={"rgba(0, 0, 0, 0.5)"} />*/}
          {/*        )}*/}
          {/*      </Pressable>*/}
          {/*    )}*/}
          {/*  </Offline>*/}
          {/*)}*/}

          <VStack alignItems={"center"} height={"100%"} width={"100%"}>
            <Pressable
              key={item.id}
              height={"100%"}
              justifyContent={"center"}
              borderRadius={"10px"}
              width={"100%"}
              _hover={{ bgColor: "#EEEEEE" }}
              onPress={() => {
                navigate(`/profile/${item?.id}/${item?.region}`, {
                  state: {
                    user: {
                      id: item?.id,
                      pk: item?.pk,
                      region: item?.region,
                      type: item?.type,
                      name: item?.title,
                    },
                  },
                });
              }}
            >
              {isAdminView &&
                (showEditLoader && isMemberData?.id === item?.id ? (
                  <Spinner
                    size="sm"
                    position="absolute"
                    right="8px"
                    top="10px"
                    color="gray.500"
                    zIndex={999}
                  />
                ) : (
                  <Pressable
                    position={"absolute"}
                    right={"8px"}
                    zIndex={999}
                    top={"10px"}
                    onPress={() => {
                      setIsOpen(!isOpen);
                      setIsMemberData(item);
                    }}
                  >
                    <MoreHorizontalIcon
                      size={"20px"}
                      color={"gray.600"}
                      style={{ transform: [{ rotate: "90deg" }] }}
                    />
                  </Pressable>
                ))}

              {isOpen && isMemberData?.id == item?.id && (
                <VStack
                  width={"128px"}
                  ref={menuRefs}
                  height="auto"
                  shadow={2}
                  background={"#FFFFFF"}
                  position={"absolute"}
                  top={"10px"}
                  right={"30px"}
                  zIndex={999}
                  borderRadius={"6px"}
                >
                  {/*{currentUser?.silenced?.filter((x) => x?.id == item?.id)*/}
                  {/*  ?.length == 0 ? (*/}
                  {/*  <Button*/}
                  {/*    width={"100%"}*/}
                  {/*    height={"36px"}*/}
                  {/*    alignItems={"center"}*/}
                  {/*    justifyContent={"flex-start"}*/}
                  {/*    backgroundColor={isSlienceLoad ? "gray.400" : "white"}*/}
                  {/*    isLoading={isSlienceLoad}*/}
                  {/*    onPress={() => HandleSlience(item)}*/}
                  {/*  >*/}
                  {/*    <Text fontSize={"14px"} fontFamily={"Roboto"}>*/}
                  {/*      {Loc.currentLang.menu.silence}*/}
                  {/*    </Text>*/}
                  {/*  </Button>*/}
                  {/*) : (*/}
                  {/*  <Button*/}
                  {/*    width={"100%"}*/}
                  {/*    height={"36px"}*/}
                  {/*    alignItems={"center"}*/}
                  {/*    justifyContent={"flex-start"}*/}
                  {/*    isLoading={unSlienceLoad}*/}
                  {/*    backgroundColor={unSlienceLoad ? "gray.400" : "white"}*/}
                  {/*    onPress={() => HandleUnSlience(item)}*/}
                  {/*  >*/}
                  {/*    <Text fontSize={"14px"} fontFamily={"Roboto"}>*/}
                  {/*      {Loc.currentLang.menu.unSilence}*/}
                  {/*    </Text>*/}
                  {/*  </Button>*/}
                  {/*)}*/}

                  {/*<Divider />*/}
                  <Button
                    width={"100%"}
                    height={"36px"}
                    alignItems={"center"}
                    justifyContent={"flex-start"}
                    isLoading={showEditLoader}
                    backgroundColor={isLoading ? "gray.400" : "white"}
                    onPress={() => HandleRemoveMembers(item)}
                  >
                    <Text fontSize={"14px"} fontFamily={"Roboto"}>
                      {Loc.currentLang.menu.delete}
                    </Text>
                  </Button>
                </VStack>
              )}

              {item?.thumb && (
                <Box
                  bgColor={"#FF6600"}
                  borderRadius={["full"]}
                  width={"70px"}
                  height={"70px"}
                  alignSelf={"center"}
                  p={0}
                >
                  <Image
                    source={{
                      uri: AV.Media.getThumb(item),
                    }}
                    borderRadius={["full"]}
                    width={"100%"}
                    height={["100%"]}
                  />
                </Box>
              )}

              {!item?.thumb && (
                <Box alignItems={"center"}>
                  <Profile height={"70"} width={"70"} color={"#32AE78"} />
                </Box>
              )}

              <Tooltip label={item.title} openDelay={500}>
                <Pressable
                  alignItems={"center"}
                  justifyContent={"center"}
                  onPress={() => {
                    navigate(`/profile/${item?.id}/${item?.region}`, {
                      state: {
                        user: {
                          id: item?.id,
                          pk: item?.pk,
                          region: item?.region,
                          type: item?.type,
                          name: item?.title,
                        },
                      },
                    });
                  }}
                >
                  <Text
                    marginTop={"28px"}
                    justifyContent={"center"}
                    alignItems={"center"}
                    width="120px"
                    fontSize={"14px"}
                    fontWeight={500}
                    numberOfLines={1}
                    textAlign="center"
                  >
                    {item.title}
                  </Text>
                </Pressable>
              </Tooltip>
            </Pressable>
          </VStack>
        </Box>
      </>
    );
  };

  const RenderStaffTab = ({ entityData, setIsConvoData, setIsOpenConvo }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const dimensions = useWindowDimension();
    const isMobile = dimensions?.width <= 500;
    const isLMobile = dimensions?.width <= 767 || false;
    const isTab = dimensions?.width <= 1300 || false;

    const [staffEmail, setStaffEmail] = useState("");
    const [staffPhone, setStaffPhone] = useState("");
    const [staffPic, setStaffPic] = useState<any>("");
    const [staffRole, setStaffRole] = useState<any>("");
    const [isStaffEdit, setIsStaffEdit] = useState(false);
    const [editStaffItem, setEditStaffItem] = useState<any>();
    const [isPicLoader, setIsPicLoader] = useState(false);
    const [error, setError] = useState<any>(null);
    const [itemSelectStaff, setItemSelectStaff] = useState<any>("");
    const [selectTypeStaff, setSelectTypeStaff] = useState<string>();
    const [staffList, setStaffList] = useState<any>(entityData?.staff);
    const [contactStaffList, setContactStaffList] = useState<any>();
    const [menuStaff, setMenuStaff] = useState<any>("");
    const [newNameStaff, setNewNameStaff] = useState<string>("");
    const [newMailStaff, setNewMailStaff] = useState<string>("");
    const [isEditStaffDetails, setIsEditStaffDetails] = useState(false);
    const [isConfirmDeleteStaff, setisConfirmDeleteStaff] = useState(false);
    const [confirmationTextStaff, setConfirmationTextStaff] = useState("");
    const [showFileuploadModalStaff, setshowFileuploadModalStaff] =
      useState(false);
    const [showAddProfileModalStaff, setShowAddProfileModalStaff] =
      useState(false);
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    const customSelectStyle = {
      maxHeight: "40px", // Set your desired height here
      width: "230px",
    };

    const customSelectStyleeeess = {
      maxHeight: "32px", // Set your desired height here
    };

    useEffect(() => {
      //const isAdminOrStaff = entityData?.staff?.some(
      //  (x) => x?.id === currentUser?.id,
      //);
      //setIsAdminView(isAdminOrStaff);
      setIsStaff(true);
      setStaffList(entityData?.staff);
    }, [entityData, currentUser]);

    const handleProfileType = async (type) => {
      setIsMember(false);
      setIsStaff(true);

      setStaffEmail("");
      setStaffPhone("");
      setError(null);
      setStaffRole("");
      setShowAddProfileModalStaff(true);
    };

    const handleStaffRole = (e) => {
      e.preventDefault();
      setStaffRole(e.target.value);
    };

    const HandleRemoveStaff = (item) => {
      setisConfirmDeleteStaff(true);
      setConfirmationTextStaff(Loc.currentLang.menu.deleteStaffConfirmText);
      setItemSelectStaff(item);
      setSelectTypeStaff("DeleteStaff");
    };

    const HandleDeleteStaff = async () => {
      setShowEditLoader(true);

      let removeStaff = await AV.OrgBase.removeStaff(
        AV.AVEntity.getFk(entityData),
        {
          id: itemSelectStaff.id,
          pk: itemSelectStaff.pk,
          type: "Person",
          role: itemSelectStaff.role,
        },
      );

      if (removeStaff !== null) {
        setEntityData(removeStaff);
        setStaffList(removeStaff?.staff);
      }

      setShowEditLoader(false);
      setisConfirmDeleteStaff(false);
    };

    const getMedia = async (file?: any) => {
      let iMedia = await AV.Media.saveFiles(
        AV.Media.getFormData(file),
        entityData?.region ? entityData?.region : currentUser?.region,
      );

      setIsPicLoader(false);
      return iMedia[0];
    };

    const {
      getRootProps: getStaffProfilePicFile,
      getInputProps: getStaffProfileInputProps,
    } = useDropzone({
      accept: "image/*",
      onDrop: (acceptedFiles: any) => {
        if (
          acceptedFiles?.filter((x) => x?.type.startsWith("image")) &&
          acceptedFiles?.length > 0
        ) {
          setIsPicLoader(true);
          getMedia(acceptedFiles).then((res) => {
            editStaffItem.linkPic = res;
            setStaffPic(AV.Media.getURL(res));
          });
        } else {
          let clientError = { message: "Invalid file type" };
          CustomToast({ clientError });
          return;
        }
      },
    });

    const handleEditStaff = async (item) => {
      if (staffEmail) {
        if (!emailRegex.test(staffEmail)) {
          let clientError = { message: "Invalid Email" };
          CustomToast({ clientError });
          return;
        }
      }

      setShowEditLoader(true);
      setError("");

      let staff: AV.IStaff = item;
      let role: AV.IRole = staff?.role;
      staff.phone = staffPhone;
      staff.email = staffEmail;
      //staff.linkPic = staffpic;
      role.name = staffRole;

      let staffEdit = await AV.OrgBase.updateStaff(
        AV.AVEntity.getFk(entityData),
        staff,
      );

      if (staffEdit) {
        setEntityData(staffEdit);
        setStaffList(staffEdit?.staff);
      }

      setIsStaffEdit(false);
      setShowEditLoader(false);
    };

    const handleUpdateStaff = async (item) => {
      let roles = entityData?.roles?.filter((x) => x?.name === "Staff")[0];
      menuStaff.role = roles;

      if (newNameStaff?.trim()?.length > 0) menuStaff.name = newNameStaff;
      if (newMailStaff?.trim()?.length > 0) menuStaff.email = newMailStaff;

      setMenuStaff(menuStaff);
      contactStaffList[contactStaffList.indexOf(item)] = menuStaff;
      setContactStaffList(contactStaffList);

      setMenuStaff("");
      setNewNameStaff("");
      setNewMailStaff("");
      setIsEditStaffDetails(false);
    };

    const handleRemoveStaff = async (item) => {
      setContactStaffList(contactStaffList?.filter((x) => x !== item));
    };

    const handleAddContactStaffList = async () => {
      setShowEditLoader(true);
      setIsEditStaffDetails(false);

      for (var i = 0; i < contactStaffList.length; i++) {
        if (!contactStaffList[i]?.role)
          contactStaffList[i].role = entityData?.roles[0];
      }
      let val = await AV.OrgBase.addStaffs(
        AV.AVEntity.getFk(entityData),
        contactStaffList,
      );
      if (val) setStaffList(val?.staff);

      setShowEditLoader(false);
      setshowFileuploadModalStaff(false);
      setShowAddProfileModalStaff(false);
    };

    return (
      <Box
        minHeight="340px"
        borderRadius={5}
        backgroundColor="AVColor.white"
        shadow={1}
        flex={1}
        mb={3}
      >
        <VStack zIndex={-3}>
          <HStack alignItems={"center"} justifyContent={"space-between"}>
            <Text
              fontWeight={"500"}
              marginLeft={"15px"}
              fontSize={"22px"}
              color={"AVColor.primary"}
              py={"12px"}
            >
              {Loc.currentLang.menu.staff}
            </Text>

            <HStack alignItems={"center"} zIndex={-3}>
              <Tooltip
                label={Loc.currentLang.huddles.staffTab}
                w={200}
                openDelay={500}
              >
                <Box
                  marginRight={"10px"}
                  p={"9px"}
                  shadow={1}
                  zIndex={-3}
                  backgroundColor={"AVColor.liteBg"}
                  rounded={"full"}
                >
                  <img
                    src={helping}
                    height={"17px"}
                    width={"17px"}
                    style={{ zIndex: -3 }}
                  />
                </Box>
              </Tooltip>

              {/*{isAdminView && (*/}
              {/*  <Tooltip label={Loc.currentLang.menu.editRoles} openDelay={500}>*/}
              {/*    <Pressable*/}
              {/*      backgroundColor={"AVColor.liteBg"}*/}
              {/*      rounded={"full"}*/}
              {/*      p={"10px"}*/}
              {/*      marginRight={"10px"}*/}
              {/*      _hover={{ backgroundColor: "AVColor.hovercolor" }}*/}
              {/*      onPress={() => {*/}
              {/*        navigate(*/}
              {/*          `/accountsettings/${entityData?.id}/${entityData?.region}`,*/}
              {/*          {*/}
              {/*            state: {*/}
              {/*              page: window.location.pathname,*/}
              {/*              Entity: entityData,*/}
              {/*              isEdit: true,*/}
              {/*            },*/}
              {/*          },*/}
              {/*        );*/}
              {/*      }}*/}
              {/*    >*/}
              {/*      <EditIcon size="20px" />*/}
              {/*    </Pressable>*/}
              {/*  </Tooltip>*/}
              {/*)}*/}

              {isAdminView && (
                <Button
                  isDisabled={!isOnline}
                  p={"10px"}
                  shadow={1}
                  bgColor={"gray.100"}
                  _hover={{ bgColor: "gray.50" }}
                  rounded={"full"}
                  marginRight={"3px"}
                  onPress={() => handleProfileType("Staff")}
                >
                  <AddIcon size={"20px"} color={"#32AE78"} />
                </Button>
              )}
            </HStack>
          </HStack>
        </VStack>

        <Divider my={2} zIndex={-3} />

        <HStack flexWrap={"wrap"} width={"100%"}>
          <FlatList
            width={"100%"}
            data={staffList}
            scrollEnabled={true}
            ListEmptyComponent={
              <Center height={200}>{Loc.currentLang.menu.noStaffsFound}</Center>
            }
            renderItem={(item: any) => (
              <StaffsCard
                entity={entityData}
                data={item}
                {...props}
                key={item?.id}
                item={item}
                setStaffList={setStaffList}
                Editstaffitem={editStaffItem}
                setEditstaffitem={setEditStaffItem}
                staffList={staffList}
                setIsStaffEdit={setIsStaffEdit}
                setstaffemail={setStaffEmail}
                setstaffphone={setStaffPhone}
                setStaffRole={setStaffRole}
                setstaffpic={setStaffPic}
                HandleRemoveStaffs={HandleRemoveStaff}
                setIsOpenConvo={setIsOpenConvo}
                setIsConvoData={setIsConvoData}
                isHuddlesStaff={true}
              />
            )}
            showsVerticalScrollIndicator={false}
            numColumns={isMobile ? 1 : isTab ? 2 : 3}
          />
        </HStack>

        {isStaffEdit && (
          <Box
            position="fixed"
            bgColor={"AVColor.overlay2"}
            bottom={0}
            right={0}
            top={0}
            left={0}
            zIndex={99}
          >
            <div
              style={{
                position: "fixed",
                top: "58%",
                left: "53%",
                width: "90%",
                transform: "translate(-53%, -50%)",
                background: "#ffffff",
                boxShadow:
                  "0 12px 28px 0 rgba(0, 0, 0, 0.2), 0 2px 4px 0 rgba(0, 0, 0, 0.1), inset 0 0 0 1px rgba(255, 255, 255, 0.5)",
                minWidth: isMobile ? "320px" : isLMobile ? "480px" : "600px",
                maxWidth: "1000px",
                borderRadius: "8px",
                minHeight: "300px",
              }}
            >
              <VStack
                flex={1}
                minHeight={isMobile ? "600px" : "450px"}
                maxHeight={"625px"}
              >
                <HStack
                  alignItems={"center"}
                  justifyContent={"space-between"}
                  borderBottomColor={"AVColor.grey"}
                  px={5}
                  zIndex={99}
                  marginTop={"10px"}
                >
                  <Text fontSize={24}>
                    {Loc.currentLang.menu.editStaffMember}
                  </Text>
                  <HStack justifyContent={"flex-end"}>
                    <AVCancel
                      color={undefined}
                      size={undefined}
                      callback={() => setIsStaffEdit(false)}
                    />
                  </HStack>
                </HStack>

                <Pressable zIndex={-3}>
                  <Box p={1} borderRadius={"full"}>
                    <HStack space={2} px={2}>
                      {editStaffItem?.thumb || editStaffItem?.linkPic ? (
                        <Box
                          bgColor={"#FF6600"}
                          borderRadius={["full"]}
                          width={"70px"}
                          height={"70px"}
                          left={"1px"}
                          p={0}
                        >
                          <Image
                            source={{
                              uri: editStaffItem?.linkPic
                                ? AV.Media.getURL(editStaffItem?.linkPic)
                                : AV.Media.getThumb(editStaffItem),
                            }}
                            borderRadius={["full"]}
                            //top={ "2" }
                            width={"100%"}
                            height={["100%"]}
                          />
                          <Button
                            bgColor={"AVColor.white"}
                            position={"absolute"}
                            top={"45px"}
                            right={"-6px"}
                            p={0}
                            rounded={"full"}
                            _hover={{ backgroundColor: "AVColor.hovercolor" }}
                            shadow={1}
                            zIndex={99}
                            isLoading={isPicLoader}
                            _spinner={{ color: "AVColor.black" }}
                          >
                            <Box
                              {...getStaffProfilePicFile({
                                className: "dropzone",
                              })}
                            >
                              <input {...getStaffProfileInputProps()} />
                              <AddPhotoIcon size={18} p={1} />
                            </Box>
                          </Button>
                        </Box>
                      ) : (
                        <Box alignItems={"center"}>
                          <Profile
                            height={"70"}
                            width={"70"}
                            color={"#32AE78"}
                          />

                          <Button
                            bgColor={"AVColor.white"}
                            position={"absolute"}
                            top={"45px"}
                            right={"-6px"}
                            p={0}
                            rounded={"full"}
                            _hover={{ backgroundColor: "AVColor.hovercolor" }}
                            shadow={1}
                            zIndex={99}
                            isLoading={isPicLoader}
                            _spinner={{ color: "AVColor.black" }}
                          >
                            <Box
                              {...getStaffProfilePicFile({
                                className: "dropzone",
                              })}
                            >
                              <input {...getStaffProfileInputProps()} />
                              <AddPhotoIcon size={18} p={1} />
                            </Box>
                          </Button>
                        </Box>
                      )}
                      <Text
                        marginTop={"20px"}
                        left={"2px"}
                        marginLeft={"35px"}
                        alignItems="center"
                        width="300px"
                        numberOfLines={1}
                        textAlign="center"
                        zIndex={-3}
                        fontSize={24}
                      >
                        {editStaffItem?.title}
                      </Text>
                    </HStack>
                  </Box>
                </Pressable>

                <HStack
                  alignItems={"center"}
                  display={"block"}
                  borderBottomColor={"AVColor.grey"}
                  px={5}
                  py={5}
                  zIndex={99}
                >
                  <VStack marginTop={"15px"}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        {Loc.currentLang.menu.assignRoleReq}
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={staffRole}
                        label={Loc.currentLang.menu.assignRoleReq}
                        onChange={handleStaffRole}
                      >
                        {entityData?.roles?.map((option) => (
                          <MenuItem key={option?.name} value={option?.name}>
                            {option?.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </VStack>

                  <VStack marginTop={"15px"}>
                    <AVInputtext
                      type={"text"}
                      onChange={(e) =>
                        setStaffPhone(e.target.value.replace(/[^0-9]/g, ""))
                      }
                      value={staffPhone}
                      label={Loc.currentLang.menu.phone}
                      height={"15px"}
                      width={isMobile ? "245px" : "200px"}
                      maxLength={50}
                      defaultValue={undefined}
                      minRows={undefined}
                      multiline={undefined}
                      placeholder={undefined}
                      size={undefined}
                    />
                  </VStack>

                  <VStack marginTop={"15px"}>
                    <AVInputtext
                      type={"text"}
                      onChange={(e) => setStaffEmail(e.target.value)}
                      value={staffEmail}
                      label={Loc.currentLang.menu.emailAddressNotReq}
                      height={"15px"}
                      width={isMobile ? "245px" : "200px"}
                      maxLength={50}
                      defaultValue={undefined}
                      minRows={undefined}
                      multiline={undefined}
                      placeholder={undefined}
                      size={undefined}
                    />
                  </VStack>
                </HStack>

                <HStack
                  width={"100%"}
                  height="100%"
                  space={5}
                  flex={1}
                  justifyContent={"center"}
                  px={5}
                  m={3}
                  zIndex={-1}
                >
                  <Button
                    rounded="full"
                    backgroundColor={"#EEEEEE"}
                    paddingX={"20px"}
                    width={isMobile ? "40%" : "24%"}
                    height={"40px"}
                    onPress={() => {
                      setIsStaffEdit(false);
                    }}
                  >
                    <Text
                      fontSize={"14px"}
                      color={"rgba(0,0,0,0.5)"}
                      fontWeight={"bold"}
                    >
                      {Loc.currentLang.menu.cancel}
                    </Text>
                  </Button>

                  <Button
                    rounded="full"
                    backgroundColor={"#32AE78"}
                    paddingX={"20px"}
                    onPress={() => {
                      handleEditStaff(editStaffItem);
                    }}
                    isLoading={showEditLoader}
                    isLoadingText={Loc.currentLang.menu.saveLoad}
                    width={isMobile ? "40%" : "24%"}
                    height={"40px"}
                  >
                    <Text fontSize={"14px"} color={"white"}>
                      {Loc.currentLang.menu.save}
                    </Text>
                  </Button>
                </HStack>

                {error && (
                  <HStack justifyContent={"center"} marginBottom={"10px"}>
                    <Text color={"red.500"} fontWeight={400}>
                      {error}
                    </Text>
                  </HStack>
                )}
              </VStack>
            </div>
          </Box>
        )}

        {showAddProfileModalStaff && (
          <AVPersonaModal
            isMember={false}
            isParticipant={false}
            setShowAddProfileModal={setShowAddProfileModalStaff}
            isStaff={isStaff}
            Entity={entityData}
            setEntity={setEntityData}
            setcontactList={setContactStaffList}
            setshowFileuploadModal={setshowFileuploadModalStaff}
            setStaffList={setStaffList}
            setmemberList={undefined}
            isPlayer={false}
            setPlayersList={undefined}
            showAddProfileModal={showAddProfileModalStaff}
            isTeam={false}
            searchTypes={""}
            setOrgList={undefined}
            setGroupList={undefined}
            isEditEntireSeries={false}
            seriesEvent={undefined}
          />
        )}

        {isConfirmDeleteStaff && (
          <AVConfirmationModal
            showconfirmationPopup={isConfirmDeleteStaff}
            setshowconfirmationPopup={setisConfirmDeleteStaff}
            Confirmationtext={confirmationTextStaff}
            type={selectTypeStaff}
            item={itemSelectStaff}
            function={HandleDeleteStaff}
            isLoader={showEditLoader}
          />
        )}

        {/* FileUploadModal Popup */}
        {showFileuploadModalStaff && (
          <Box
            position="fixed"
            bgColor={"AVColor.overlay2"}
            bottom={0}
            right={0}
            top={0}
            left={0}
            zIndex={99}
          >
            <Modal.Content
              bgColor={"#fff"}
              maxWidth={"100%"}
              width={"50%"}
              padding={"24px"}
              minHeight={[500]}
              left={"22%"}
              top={"20%"}
            >
              <HStack fontSize={"24px"} fontWeight={400} marginBottom={"24px"}>
                {Loc.currentLang.menu.staff}
              </HStack>

              <VStack
                alignItems={"center"}
                space={4}
                width={"auto"}
                overflowY={"auto"}
                height={"334px"}
                justifyContent={"flex-start"}
              >
                <HStack
                  flexWrap={"wrap"}
                  alignSelf={"flex-start"}
                  space={6}
                  zIndex={-1}
                  justifyContent={"center"}
                  height={"145px"}
                  width={"98%"}
                >
                  {contactStaffList?.map((item, index) => (
                    <React.Fragment key={index}>
                      <HStack
                        alignItems={"center"}
                        borderStyle={"solid"}
                        borderColor={"rgba(0, 0, 0, 0.05)"}
                        borderRadius={"5px"}
                        width={"100%"}
                        height={"40px"}
                      >
                        <HStack width={"85%"}>
                          <HStack marginRight={"10px"} width={"30%"}>
                            {!isEditStaffDetails || menuStaff !== item ? (
                              <Text
                                fontWeight="500"
                                numberOfLines={1}
                                ellipsizeMode={"tail"}
                                fontSize={"16px"}
                                textAlign={"left"}
                                color={"#000000"}
                                width={"100%"}
                                textTransform={"capitalize"}
                              >
                                {item?.name}
                              </Text>
                            ) : (
                              <Box width={"80%"} marginTop={"3px"}>
                                <Input
                                  textAlign={"left"}
                                  fontSize={"16px"}
                                  paddingLeft={"0px"}
                                  paddingRight={"0px"}
                                  value={newNameStaff}
                                  defaultValue={menuStaff?.name}
                                  onChangeText={(e) => setNewNameStaff(e)}
                                />
                              </Box>
                            )}
                          </HStack>

                          <HStack width={"48%"} marginRight={"10px"}>
                            {!isEditStaffDetails || menuStaff !== item ? (
                              <Text
                                fontSize={"16px"}
                                width={"100%"}
                                numberOfLines={1}
                                ellipsizeMode={"tail"}
                                textAlign={"left"}
                                textTransform={"capitalize"}
                              >
                                {item?.email}
                              </Text>
                            ) : (
                              <Box width={"80%"} marginTop={"3px"}>
                                <Input
                                  textAlign={"left"}
                                  fontSize={"16px"}
                                  paddingLeft={"0px"}
                                  paddingRight={"0px"}
                                  value={newMailStaff}
                                  defaultValue={menuStaff?.email}
                                  onChangeText={(e) => setNewMailStaff(e)}
                                />
                              </Box>
                            )}
                          </HStack>

                          {isStaff && (
                            <HStack width={"16%"} marginRight={"10px"}>
                              {!isEditStaffDetails || menuStaff !== item ? (
                                <Text
                                  fontSize={"16px"}
                                  width={"100%"}
                                  textAlign={"left"}
                                  color={"#000000"}
                                >
                                  {isStaff
                                    ? item?.role?.name
                                      ? item?.role?.name
                                      : entityData?.roles[0]?.name
                                    : ""}
                                </Text>
                              ) : (
                                <HStack width={"65%"} marginTop={"10px"}>
                                  <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">
                                      {Loc.currentLang.menu.roles}
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      value={staffRole}
                                      label={Loc.currentLang.menu.roles}
                                      onChange={(e) =>
                                        setStaffRole(e.target.value)
                                      }
                                      style={
                                        isMobile
                                          ? customSelectStyle
                                          : customSelectStyleeeess
                                      }
                                    >
                                      {entityData?.roles?.map((option) => (
                                        <MenuItem
                                          key={option?.name}
                                          value={option?.name}
                                        >
                                          {option?.name}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                </HStack>
                              )}
                            </HStack>
                          )}
                        </HStack>

                        <HStack position={"absolute"} right={0} space={3}>
                          {(!isEditStaffDetails || menuStaff !== item) && (
                            <Button
                              backgroundColor={"white"}
                              width={"50px"}
                              height={"40px"}
                              isDisabled={showEditLoader}
                              onPress={() => {
                                setMenuStaff(item);
                                setNewMailStaff(item?.email);
                                setNewNameStaff(item?.name);
                                setStaffRole(
                                  item?.role?.name
                                    ? item?.role?.name
                                    : entityData?.roles[0]?.name,
                                );
                                setIsEditStaffDetails(true);
                              }}
                            >
                              <HStack>
                                <Text
                                  fontSize={"16px"}
                                  underline
                                  textAlign={"center"}
                                  color={"#00A7BC"}
                                >
                                  {Loc.currentLang.menu.edit}
                                </Text>
                              </HStack>
                            </Button>
                          )}{" "}
                          {isEditStaffDetails && menuStaff === item && (
                            <Button
                              backgroundColor={"white"}
                              width={"50px"}
                              height={"40px"}
                              onPress={() => {
                                handleUpdateStaff(item);
                              }}
                            >
                              <HStack>
                                <Text
                                  fontSize={"16px"}
                                  underline
                                  textAlign={"center"}
                                  color={"#00A7BC"}
                                >
                                  {Loc.currentLang.menu.update}
                                </Text>
                              </HStack>
                            </Button>
                          )}
                          <Button
                            backgroundColor={"white"}
                            height={"40px"}
                            width={"50px"}
                            isDisabled={showEditLoader}
                            onPress={() => handleRemoveStaff(item)}
                          >
                            <HStack>
                              <Text
                                fontSize={"16px"}
                                underline
                                textAlign={"center"}
                                color={"#DF2827"}
                              >
                                {Loc.currentLang.menu.delete}
                              </Text>
                            </HStack>
                          </Button>
                        </HStack>
                      </HStack>
                      <Divider marginTop={"5px"} />
                    </React.Fragment>
                  ))}
                </HStack>
              </VStack>

              <HStack
                width={"100%"}
                space={5}
                flex={1}
                justifyContent={"flex-end"}
                alignItems={"top"}
                pr={5}
                top={"88%"}
                position="absolute"
                right="10px"
                maxHeight={"200px"}
                padding={0}
                background={"none"}
              >
                <Button
                  background={"#EEEEEE"}
                  borderRadius={15}
                  px={16}
                  height={"40px"}
                  width={"40px"}
                  rounded="full"
                  onPress={() => {
                    setshowFileuploadModalStaff(false);
                  }}
                >
                  <Text color={"#000000"}>{Loc.currentLang.menu.cancel}</Text>
                </Button>

                <Button
                  bgColor={"AVColor.primary"}
                  height={"40px"}
                  isLoading={showEditLoader}
                  isLoadingText={Loc.currentLang.menu.saveLoad}
                  width={"40px"}
                  borderRadius={15}
                  px={16}
                  rounded="full"
                  isDisabled={contactStaffList.length === 0}
                  onPress={handleAddContactStaffList}
                >
                  <Text color={"#ffffff"}>{Loc.currentLang.menu.save}</Text>
                </Button>
              </HStack>
            </Modal.Content>
          </Box>
        )}
      </Box>
    );
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case Loc.currentLang.activity.headers.chat:
        return (
          <Box flex={1}>
            {isHuddleData?.id?.trim().length > 0 &&
            isHuddleData?.id === entityData?.id ? (
              <Messages
                camera={camera}
                isSetText={isSetText}
                isHeader={false}
                isNewChat={isNewChat}
                setIsNewChat={setIsNewChat}
                isGroupChat={props?.isGroupChat}
                setIsGroupChat={props?.setIsGroupChat}
                isConvoData={props?.isConvoData}
                setIsConvoData={props?.setIsConvoData}
                setShowEmoji={setShowEmoji}
                RenderImages={RenderImages}
                showEmoji={showEmoji}
                imageInputRef={imageInputRef}
                onEmojiClick={onEmojiClick}
                handleuserRedirect={handleuserRedirect}
                getItemLayout={getItemLayout}
                ReplyLoadMedia={ReplyLoadMedia}
                setHeader={setHeader}
                setShowAllImage={setShowAllImage}
                setSingleImage={setSingleImage}
                setShowPreview={setShowPreview}
                setConvoImage={setConvoImage}
                setItemHeights={setItemHeights}
                itemHeights={itemHeights}
                props={props}
                mdlConvoVisible={mdlConvoVisible}
                textSearchRef={textSearchRef}
                mdlCreateConvoVisible={mdlCreateConvoVisible}
                typingUserName={typingUserName}
                setConvoSubject={setConvoSubject}
                setConvos={setConvos}
                isOpenConvo={true}
                setIsOpenConvo={setIsOpenConvo}
                setShowConvoListModal={setShowConvoListModal}
                setMdlCreateConvoVisible={setMdlCreateConvoVisible}
                toFK={toFK}
                searchInput={searchInput}
                filteredResults={filteredResults}
                showSearch={showSearch}
                handleExternalLink={handleExternalLink}
                externalLink={externalLink}
                showFilePicker={showFilePicker}
                handleCreateModel={handleCreateModel}
                searchItems={searchItems}
                handleSentToProfile={handleSentToProfile}
                handleSendMessage={handleSendMessage}
                setConvoLoading={setConvoLoading}
                isLoading={isLoading}
                handleSubject={handleSubject}
                subject={subject}
                isDelete={isDelete}
                setIsdelete={setIsdelete}
                setUpdateConvoImage={setUpdateConvoImage}
                setUpdateConvoVideo={setUpdateConvoVideo}
                handleMessage={handleMessage}
                handleRemoveItem={handleRemoveItem}
                getImageGalleryFromFilePickerCreateConvo={
                  getImageGalleryFromFilePickerCreateConvo
                }
                convoSubject={convoSubject}
                setMdlConvoVisible={setMdlConvoVisible}
                convoPost={convoPost}
                convo={convo}
                showConvoFilePicker={showConvoFilePicker}
                handleGetConvo={handleGetConvo}
                handleSendConvoMessage={handleSendConvoMessage}
                replyValue={replyValue}
                setreplyValue={setreplyValue}
                handleChatMessage={handleChatMessage}
                media={media}
                value={value}
                profile={profile}
                Setprofile={Setprofile}
                setValue={setValue}
                Loading={Loading}
                images={images}
                setImages={setImages}
                setDeletedImages={setDeletedImages}
                setItemEdit={setItemEdit}
                videoUrls={videoUrls}
                isOpenBox={isOpenBox}
                setIsOpenBox={setIsOpenBox}
                setExternalLink={setExternalLink}
                HandleAddOneDrive={HandleAddOneDrive}
                setShowExternalLinkInput={setShowExternalLinkInput}
                showExternalLinkInput={showExternalLinkInput}
                HandleAddDropBoxLink={HandleAddDropBoxLink}
                setIsOpenCemera={setIsOpenCemera}
                handleOpenPicker={handleOpenPicker}
                isOpenCemera={isOpenCemera}
                HandleAddExternalUrl={HandleAddExternalUrl}
                setvideos={setvideos}
                handleImages={handleImages}
                handleVoice={handleVoice}
                handleFilePicker={handleFilePicker}
                onRefresh={onRefresh}
                setSubject={setSubject}
                settoFK={settoFK}
                handlePublish={handlePublish}
                setIsHide={setIsHide}
                isHide={isHide}
                isImageProcessing={isImageProcessing}
                setMedia={setMedia}
                refConvoList={refConvoList}
                setShowConvoFilePicker={setShowConvoFilePicker}
                HandleEditSet={HandleEditSet}
                handleUpdatePost={handleUpdatePost}
                itemEdit={itemEdit}
                isYoutube={isYoutube}
                setIsYouTube={setIsYouTube}
                editingImage={editingImage}
                setSearchInput={setSearchInput}
                setShowSearch={setShowSearch}
                setEditingImage={setEditingImage}
                setConvoPost={setConvoPost}
                fetchloading={fetchloading}
                isHuddleChatTab={true}
                shrink={shrink}
                setShrink={setShrink}
                translateItem={translateItem}
                handleTranslateText={handleTranslateText}
                handleShowOriginalText={handleShowOriginalText}
                setIsOneDriveData={setIsOneDriveData}
                showInsufficientCredits={showInsufficientCredits}
                setShowInsufficientCredits={setShowInsufficientCredits}
                scrollRef={scrollRef}
                prevScrollHeightRef={prevScrollHeightRef}
                prevScrollTopRef={prevScrollTopRef}
                loadingOldMessagesRef={loadingOldMessagesRef}
                messagesEndRef={messagesEndRef}
                setupSignalRConnection={setupSignalRConnection}
                cameraMode={cameraMode}
                setCameraMode={setCameraMode}
                webcamRef={webcamRef}
                recording={recording}
                setRecording={setRecording}
                duration={duration}
                setDuration={setDuration}
                formatDuration={formatDuration}
                toggleMode={toggleMode}
                isCancelledRef={isCancelledRef}
                handleCameraPhotoCapture={handleCameraPhotoCapture}
                handleStartRecording={handleStartRecording}
                handleStopRecording={handleStopRecording}
                onClose={onClose}
                addLinkLoad={addLinkLoad}
                setAddLinkLoad={setAddLinkLoad}
                editorRef={editorRef}
                useRichText={useRichText}
                setUseRichText={setUseRichText}
                rteValue={rteValue}
                setRteValue={setRteValue}
                toolbarOptions={toolbarOptions}
                isExpanded={isExpanded}
                setIsExpanded={setIsExpanded}
                setPostPopupExpanded={setPostPopupExpanded}
                bgColor={bgColor}
                setBgColor={setBgColor}
                bgImage={bgImage}
                setBgImage={setBgImage}
                bgImgWidth={bgImgWidth}
                setBgImgWidth={setBgImgWidth}
                bgImgHeight={bgImgHeight}
                setBgImgHeight={setBgImgHeight}
                clickedUrl={clickedUrl}
                setClickedUrl={setClickedUrl}
                showConfirmLinkPopup={showConfirmLinkPopup}
                setShowConfirmLinkPopup={setShowConfirmLinkPopup}
                entityData={entityData}
                isGameEnded={false}
              />
            ) : (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="100%"
              >
                <p>{Loc.currentLang.menu.noHuddlesFound}</p>
              </Box>
            )}
          </Box>
        );
      case Loc.currentLang.activity.headers.post:
        return (
          <Box flex={1}>
            {isHuddleData?.id?.trim().length > 0 &&
            isHuddleData?.id === entityData?.id ? (
              <AVFeedsProfile
                page={"Profile"}
                isOwner={false}
                Entity={entityData}
                id={entityData?.id}
                setisFeedCount={() => {}}
                isFollowing={false}
                isHuddlePostTab={true}
                {...props}
              />
            ) : (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="100%"
              >
                <p>{Loc.currentLang.menu.noHuddlesFound}</p>
              </Box>
            )}
          </Box>
        );
      case Loc.currentLang.menu.files:
        return (
          <Box flex={1}>
            {isHuddleData?.id?.trim().length > 0 &&
            isHuddleData?.id === entityData?.id ? (
              <Createalbumpopup
                isDocumentPage={true}
                Parentdata={entityData}
                isPhotoPage={false}
                albumlist={albumlist}
                isOwner={true}
                setalbumlist={setalbumlist}
                filesList={filesList}
                setfilesList={setfilesList}
                filesListany={undefined}
                editAccess={false}
                helpText={undefined}
              />
            ) : (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="100%"
              >
                <p>{Loc.currentLang.menu.noHuddlesFound}</p>
              </Box>
            )}
          </Box>
        );
      case Loc.currentLang.menu.members:
        return (
          <Box flex={1}>
            {isHuddleData?.id?.trim().length > 0 &&
            isHuddleData?.id === entityData?.id ? (
              <RenderMembersTab
                entityData={entityData}
                currentUser={currentUser}
                userconvo={userconvo}
                handleSendSingleChat={handleSendSingleChat}
                setIsConvoData={setIsConvoData}
                setIsOpenConvo={setIsOpenConvo}
                setEntitydata={setEntityData}
              />
            ) : (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="100%"
              >
                <p>{Loc.currentLang.menu.noHuddlesFound}</p>
              </Box>
            )}
          </Box>
        );
      case Loc.currentLang.menu.staff:
        return (
          <Box flex={1}>
            {isHuddleData?.id?.trim().length > 0 &&
            isHuddleData?.id === entityData?.id ? (
              <RenderStaffTab
                entityData={entityData}
                setIsConvoData={setIsConvoData}
                setIsOpenConvo={setIsOpenConvo}
              />
            ) : (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="100%"
              >
                <p>{Loc.currentLang.menu.noHuddlesFound}</p>
              </Box>
            )}
          </Box>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <AVBody
        type="huddlesList"
        setIshuddleData={setIshuddleData}
        setIsOpenConvo={setIsOpenConvo}
        isOpenConvo={IsOpenConvo}
        setIsConvoData={setIsConvoData}
        setCreateType={setCreateType}
        createType={createType}
        setShowCreateNewPage={setShowCreateNewPage}
        showCreateNewPage={showCreateNewPage}
        setIsShowEdit={setIsShowEdit}
        //unReadConvo={unReadConvo}
        fromMemberTabHuddle={location?.state?.fromMemberTabHuddle}
        {...props}
      >
        <Box
          bgColor={"AVColor.white"}
          borderRadius="8px"
          shadow={4}
          borderColor={"AVColor.buttonBg"}
          height="100%"
          display="flex"
          flexDirection="column"
          position="relative"
        >
          {/* Fixed Header */}
          <Box position="sticky" top="0" bg="white" borderTopRadius="8px">
            <HStack
              justifyContent="space-between"
              alignItems="center"
              px="6"
              py="4"
            >
              <VStack space={3}>
                <HStack alignItems="center" space={2}>
                  <Text fontWeight="400" fontSize="24px">
                    {isHuddleData?.title || Loc.currentLang.menu.huddless}
                  </Text>

                  {entityData?.status === "Deleted" && (
                    <Text color="red.500" fontSize="18px" fontWeight="500">
                      {Loc.currentLang.menu.deleted}
                    </Text>
                  )}
                </HStack>

                {!entityData?.parent || isHuddleData?.id !== entityData?.id ? (
                  <Text fontSize={"16px"} fontWeight={400} color="#A0A0A0">
                    {/* Empty or fallback text */}
                  </Text>
                ) : (
                  <Pressable
                    onPress={() => {
                      if (
                        !entityData ||
                        entityData?.parent?.id?.trim().length === 0
                      ) {
                        return;
                      }

                      const owner = entityData?.parent;
                      const { id, region, type, title, pk } = owner || {};

                      switch (type) {
                        case "PlayerOrg":
                          navigate(`/season/${id}/${region}`, {
                            state: { isCreate: false, team: owner },
                          });
                          break;
                        case "Team":
                        case "Group":
                          navigate(`/teams/${id}/${region}`, {
                            state: { isCreate: false, team: owner },
                          });
                          break;
                        case "Event":
                          let newSeriesId = id;
                          const selectedEvent = currentUser?.events?.filter(
                            (x) => x?.id === id,
                          );
                          if (
                            selectedEvent !== undefined &&
                            (selectedEvent[0]?.linkType === "Meeting" ||
                              selectedEvent[0]?.linkType === "Practice")
                          ) {
                            newSeriesId =
                              selectedEvent[0]?.events !== undefined &&
                              selectedEvent[0]?.events?.length > 0
                                ? selectedEvent[0]?.events[0].id
                                : undefined;
                          } else {
                            newSeriesId = undefined;
                          }

                          navigate(`/Events/${id}/${region}/${newSeriesId}`, {
                            state: { eventdata: selectedEvent?.[0] },
                          });
                          break;
                        case "Person":
                        case "Pet":
                          navigate(`/profile/${id}/${region}`, {
                            state: {
                              user: {
                                id: entityData?.parent?.id,
                                pk: entityData?.parent?.pk,
                                region: entityData?.parent?.region,
                                type: entityData?.parent?.type,
                                name: entityData?.parent?.title,
                              },
                            },
                          });
                          break;
                        default:
                          navigate(`/teams/${id}/${region}`, {
                            state: { isCreate: false, team: owner },
                          });
                          break;
                      }
                    }}
                  >
                    <Text
                      fontSize={"16px"}
                      fontWeight={400}
                      color="#00A7BC"
                      underline
                    >
                      {entityData?.parent?.title}
                    </Text>
                  </Pressable>
                )}
              </VStack>

              {isHuddleData?.id?.trim().length > 0 &&
              isHuddleData?.id === entityData?.id &&
              isAdminView ? (
                <Box position="relative">
                  {/* Three-dot icon */}
                  <Pressable
                    ref={menuIconRef}
                    onPress={() => setIsMenuOpen((prev) => !prev)}
                  >
                    <MoreHorizontalIcon
                      size="18px"
                      color="AVColor.primaryText"
                    />
                  </Pressable>

                  {/* Popup menu */}
                  {isMenuOpen && (
                    <Box
                      ref={menuRef}
                      position="absolute"
                      top="14px"
                      right="0"
                      bg="white"
                      borderRadius="6px"
                      py="1"
                      shadow={4}
                      zIndex={9999}
                      minW="120px"
                    >
                      {/* Edit */}
                      {entityData?.status !== "Deleted" && (
                        <Pressable
                          px="3"
                          py="2"
                          _hover={{ bg: "gray.50" }}
                          onPress={() => {
                            setIsMenuOpen(false);
                            handleEdit();
                          }}
                        >
                          <Text>{Loc.currentLang.menu.edit}</Text>
                        </Pressable>
                      )}

                      {entityData?.status !== "Deleted" && <Divider />}

                      {/* Delete / Restore */}
                      <Pressable
                        px="3"
                        py="2"
                        _hover={{ bg: "gray.50" }}
                        onPress={() => {
                          setIsMenuOpen(false);
                          handleConfirmDelete();
                        }}
                      >
                        <Text>
                          {entityData?.status === "Deleted"
                            ? Loc.currentLang.huddles.restore
                            : Loc.currentLang.menu.delete}
                        </Text>
                      </Pressable>
                    </Box>
                  )}
                </Box>
              ) : (
                currentUser?.orgs?.some((x) => x?.type === "Channel") &&
                isAdminView && (
                  <MoreHorizontalIcon
                    size={"18px"}
                    color={"AVColor.primaryText"}
                  />
                )
              )}
            </HStack>

            {/* Fixed Tabs */}
            {currentUser?.orgs?.filter((x) => x?.type === "Channel").length >
              0 && (
              <HStack
                px="6"
                borderBottomWidth="1"
                borderBottomColor="gray.100"
                zIndex={isMenuOpen ? -333 : "unset"}
              >
                {(
                  [
                    Loc.currentLang.activity.headers.chat,
                    Loc.currentLang.activity.headers.post,
                    Loc.currentLang.menu.files,
                    Loc.currentLang.menu.members,
                    Loc.currentLang.menu.staff,
                  ] as string[]
                ).map((tab) => {
                  if (
                    isHuddleData?.subType !== undefined &&
                    (tab === Loc.currentLang.menu.members ||
                      tab === Loc.currentLang.menu.staff)
                  ) {
                    return null; // skip rendering Members and Staff tabs for group convo
                  }

                  return (
                    <Pressable
                      key={tab}
                      onPress={() => setActiveTab(tab)}
                      mr="8"
                      disabled={
                        !entityData?.parent ||
                        isHuddleData?.id !== entityData?.id ||
                        entityData?.status === "Deleted"
                      }
                    >
                      <Box>
                        <Text
                          color={activeTab === tab ? "black" : "gray.600"}
                          fontSize="16px"
                          fontWeight={500}
                          pb="3"
                          borderBottomWidth="2"
                          borderBottomColor={
                            activeTab === tab
                              ? "AVColor.primary"
                              : "transparent"
                          }
                        >
                          {tab}
                        </Text>
                      </Box>
                    </Pressable>
                  );
                })}
              </HStack>
            )}
          </Box>

          {/* Scrollable Content */}
          <Box
            flex={1}
            overflow={
              activeTab === Loc.currentLang.activity.headers.chat
                ? "hidden"
                : "auto"
            }
            maxHeight={
              activeTab === Loc.currentLang.activity.headers.post
                ? "calc(100vh - 248px)"
                : "calc(100vh - 140px)"
            }
            position="relative"
          >
            {currentUser?.orgs?.filter((x) => x?.type === "Channel").length >
              0 &&
            (!entityData?.parent || isHuddleData?.id !== entityData?.id) ? (
              <Box
                position={"relative"}
                top={0}
                right={0}
                w={"100%"}
                h={"calc(100vh - 252px)"}
                bgColor={"AVColor.white"}
                shadow={"none"}
                borderColor={"AVColor.grey"}
                borderWidth={0}
                justifyContent="center"
                alignItems="center"
                zIndex={1}
              >
                <Spinner />
              </Box>
            ) : (
              renderTabContent()
            )}
          </Box>

          {/* Edit Popup */}
          {showEditPopup && (
            <Box
              position="fixed"
              bgColor={"AVColor.overlay2"}
              top="0"
              right="0"
              bottom="0"
              left="0"
              zIndex={9999}
              display="flex"
              alignItems="center"
              justifyContent="center"
              p={{ base: 3, md: 0 }}
            >
              <Box
                width={{ base: "100%", md: "600px" }}
                bg="white"
                borderRadius="8px"
                mt={{ base: 0, md: "12px" }}
                shadow="lg"
              >
                <VStack p={{ base: 4, md: 6 }} space={{ base: 4, md: 6 }}>
                  <HStack mb={{ base: 2, md: 4 }}>
                    <Text
                      fontWeight={400}
                      fontSize={{ base: "24px", md: "30px" }}
                    >
                      {Loc.currentLang.huddles.editHuddle}
                    </Text>
                  </HStack>

                  <Box mb={{ base: 3, md: 6 }}>
                    <AVInputtext
                      type="text"
                      label={`${Loc.currentLang.huddles.huddleName} *`}
                      maxLength={50}
                      onChange={(e) => setHuddleName(e.target.value)}
                      value={huddleName}
                      width="100%"
                    />
                  </Box>

                  <Box mb={{ base: 3, md: 6 }}>
                    <AVInputtext
                      type="text"
                      label={Loc.currentLang.profile.description}
                      maxLength={200}
                      onChange={(e) => setHuddleDescription(e.target.value)}
                      value={huddleDescription}
                      height={{ base: "50px", md: "60px" }}
                      minRows={2}
                      multiline={true}
                    />
                  </Box>

                  <HStack justifyContent="center" space={{ base: 3, md: 6 }}>
                    <Button
                      width={{ base: "30%", md: "20%" }}
                      height={{ base: "36px", md: "40px" }}
                      borderRadius="19px"
                      backgroundColor="#e5e5e5"
                      onPress={handleCancel}
                    >
                      <Text
                        color="rgba(0,0,0,0.5)"
                        fontWeight={500}
                        fontSize={{ base: "12px", md: "14px" }}
                      >
                        {Loc.currentLang.menu.cancel}
                      </Text>
                    </Button>

                    <Button
                      width={{ base: "30%", md: "22%" }}
                      height={{ base: "36px", md: "40px" }}
                      borderRadius="19px"
                      backgroundColor="AVColor.primary"
                      isLoading={showEditLoader}
                      isDisabled={!huddleName.trim()}
                      onPress={handleUpdate}
                    >
                      <Text
                        color="white"
                        fontWeight={500}
                        fontSize={{ base: "12px", md: "14px" }}
                      >
                        {Loc.currentLang.menu.update}
                      </Text>
                    </Button>
                  </HStack>
                </VStack>
              </Box>
            </Box>
          )}
        </Box>
      </AVBody>

      {showPreview && (
        <AVImageSlider
          slideItems={singleImage}
          setCommentValue={setCommentValue}
          previewitem={previewitem}
          setpreviewitem={setpreviewitem}
          type={"IMG"}
          settype={undefined}
          fullscreen={undefined}
          setIsFullScreen={undefined}
          setShowDetails={undefined}
          setIscommentItem={undefined}
          setIsCommentSlider={undefined}
          isCommentSlider={undefined}
          handleslideChange={undefined}
          isHeader={isHeader}
          setHeader={setHeader}
          setShowPreview={setShowPreview}
          setClickedUrl={setClickedUrl}
          setShowConfirmLinkPopup={setShowConfirmLinkPopup}
        />
      )}

      {isConfirmDelete && (
        <AVConfirmationModal
          showconfirmationPopup={isConfirmDelete}
          setshowconfirmationPopup={setisConfirmDelete}
          Confirmationtext={confirmationText}
          type={selectType}
          item={itemSelect}
          function={handleDelete}
          isLoader={showEditLoader}
        />
      )}
    </>
  );
};

export default AVHuddles;
